<template>
  <div
    :style="`background-color: ${color}; height: 800px; width: 1400px; padding:1%; border: solid 1px black; border-radius:10px ; padding-left: 0.1%; padding-right:0.1%`">
    <div class="select-section">
      <q-btn icon="close" flat round dense color="grey-8" @click="back" class="back-btn q-mr-md">
        <q-tooltip>Retour</q-tooltip>
      </q-btn>
      
      <q-separator vertical inset class="q-mx-md" />
      
      <!-- Section Édition -->
      <div class="toolbar-group">
        <q-btn dense color="red-7" class="q-mr-sm" @click="openNewTextBlock">
          Ajouter du texte
          <q-tooltip>Ajouter un bloc de texte personnalisé</q-tooltip>
        </q-btn>
        <q-btn dense color="blue-7" class="q-mr-sm" @click="showImageUploader = true">
          Ajouter une image
          <q-tooltip>Importer et ajouter une image directement</q-tooltip>
        </q-btn>
        <q-btn dense color="purple-7" class="q-mr-sm" @click="showShapeBank = true">
          <q-icon name="category" class="q-mr-xs" size="18px" />
          Éléments
          <q-tooltip>Formes, flèches et icônes bibliothèque</q-tooltip>
        </q-btn>
      </div>
      
      <q-separator vertical inset class="q-mx-md" />
      
      <!-- Section Apparence -->
      <div class="toolbar-group">
        <span class="toolbar-label">Apparence</span>
        <q-input bg-color="white" filled v-model="color" class="my-input q-mr-sm" label="Couleur de fond" dense>
          <template v-slot:append>
            <q-icon name="colorize" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-color v-model="color" />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-btn dense color="orange-6" class="q-mr-sm" @click="saveBackgroundColor">
          Appliquer
          <q-tooltip>Appliquer la couleur de fond</q-tooltip>
        </q-btn>
        
        <q-btn dense color="deep-orange-6" class="q-mr-sm" @click="showBackgroundImageSelector = true">
          Image de fond
          <q-tooltip>Choisir une image de fond</q-tooltip>
        </q-btn>
        <q-btn v-if="backgroundImage" dense color="red-6" class="q-mr-sm" @click="removeBackgroundImage">
          Supprimer
          <q-tooltip>Supprimer l'image de fond</q-tooltip>
        </q-btn>
      </div>
      
      <q-separator vertical inset class="q-mx-md" />
      
      <!-- Section Sauvegarde et Navigation -->
      <div class="toolbar-group">
        <q-btn dense color="teal-8" class="q-mr-sm" @click="saveAll">
          Sauvegarder
          <q-tooltip>Sauvegarder toutes les modifications</q-tooltip>
        </q-btn>
        <q-btn dense color="indigo-6" @click="save">
          Associer les objets
          <q-tooltip>Passer à l'étape d'association des objets</q-tooltip>
        </q-btn>
      </div>
    </div>
    <!-- <div v-if="resources.length > 0" class="text-h6" style="text-align: center;">{{ resources[0].title }}</div> -->
    <div class="screenContainer" :style="screenContainerStyle">
      
      <!-- Textes personnalisés -->
      <div v-for="(textBlock, index) in textBlocks" :key="'text-'+index" 
        class="text-block-wrapper"
        :style="{ position: 'absolute', top: textBlock.top + 'px', left: textBlock.left + 'px', zIndex: 9000 }">
        
        <!-- Contenu du texte (draggable) -->
        <div class="text-block-content"
          :style="getTextBlockContentStyle(textBlock)"
          @mousedown="startDraggingText(index, $event)"
          v-html="textBlock.content">
        </div>
        
        <!-- Poignées de redimensionnement pour les textes -->
        <div class="resize-handle top-left" @mousedown="startResizingText(index, 'top-left', $event)"></div>
        <div class="resize-handle top-right" @mousedown="startResizingText(index, 'top-right', $event)"></div>
        <div class="resize-handle bottom-left" @mousedown="startResizingText(index, 'bottom-left', $event)"></div>
        <div class="resize-handle bottom-right" @mousedown="startResizingText(index, 'bottom-right', $event)"></div>
        
        <!-- Contrôles (non-draggable) -->
        <div class="text-block-controls" :style="{ position: 'absolute', top: '-40px', left: '0', display: 'flex', gap: '5px' }">

          <q-btn round dense flat size="sm" icon="edit" @click="editTextBlock(index)" style="background-color: rgba(255,255,255,0.9);" />
          <q-btn round dense flat size="sm" icon="delete" @click="deleteTextBlock(index)" style="background-color: rgba(255,255,255,0.9);" />
          <q-btn dense flat size="sm" style="background-color: rgba(255,255,255,0.9);"
            @click="showTextBorderMenu[index] = !showTextBorderMenu[index]">
            <q-icon name="border_style" />
          </q-btn>
          <q-btn dense flat size="sm" style="background-color: rgba(255,255,255,0.9);"
            @click="showTextShadowMenu[index] = !showTextShadowMenu[index]">
            <q-icon name="blur_on" />
          </q-btn>
        </div>
        
        <!-- Menus de bordure et ombre -->
        
        <div class="borderMenu">
          <q-menu v-model="showTextBorderMenu[index]">
            <q-list style="min-width: 200px">
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Épaisseur de la bordure</p>
                  <q-slider label v-model="textBorderWidth" @change="updateTextBorderWidth(index)" />
                </q-item-section>
              </q-item>
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Couleur de la bordure</p>
                  <q-color v-model="textBorderColor" @change="updateTextBorderColor(index)" />
                </q-item-section>
              </q-item>
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Courbure de la bordure</p>
                  <q-slider label v-model="textBorderRadius" @change="updateTextBorderRadius(index)" />
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </div>
        
        <div class="shadowMenu">
          <q-menu v-model="showTextShadowMenu[index]">
            <q-list style="min-width: 200px;">
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Couleur de l'ombre</p>
                  <q-color v-model="textShadowColor" @change="updateTextShadow(index)" />
                </q-item-section>
              </q-item>
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Portée X de l'ombre</p>
                  <q-slider label v-model="textShadowX" @change="updateTextShadow(index)" />
                </q-item-section>
              </q-item>
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Portée Y de l'ombre</p>
                  <q-slider label v-model="textShadowY" @change="updateTextShadow(index)" />
                </q-item-section>
              </q-item>
              <q-item clickable v-ripple>
                <q-item-section>
                  <p>Flou de l'ombre</p>
                  <q-slider label v-model="textShadowBlur" @change="updateTextShadow(index)" />
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </div>
      </div>
      
      <div v-for="(block, index) in blocks1" :key="index" class="block"
        :style="{ top: block.top + 'px', left: block.left + 'px' }" @mousedown="startDragging(index, $event)"
        @touchstart="startDragging(index, $event)">
       
        <div class="media-container" :class="[block.animation ? `animate__animated animate__${block.animation} ${block.animationSpeed} ${block.animationDelay}` : '']" :style="{ width: `${block.width}px`, height: `${block.height}px`, position: 'relative' }">
          <img v-if="isImage(block.name)" :src="block.imgSrc" alt="Block Image" class="img"
            :style="getRotationStyle(block)" />
          <video v-else-if="isVideo(block.name)" :src="block.imgSrc" :style="getRotationStyleVideo(block)" controls
            class="video-container"></video>
          <audio v-else-if="isAudio(block.name)" :src="block.imgSrc" controls></audio>
          <embed v-else-if="isPdf(block.name)" :src="block.imgSrc" type="application/pdf" width="100%" height="400px" />
          <div v-else-if="isDocx(block.name)" class="docx-container" :style="getRotationStyle(block)">
            <div v-html="block.docContent" class="docx-content"></div>
          </div>
          <span v-else>Média non supporté</span>
          
          <!-- Poignées de redimensionnement -->
          <div class="resize-handle top-left" @mousedown="startResizing(index, 'top-left', $event)"></div>
          <div class="resize-handle top-right" @mousedown="startResizing(index, 'top-right', $event)"></div>
          <div class="resize-handle bottom-left" @mousedown="startResizing(index, 'bottom-left', $event)"></div>
          <div class="resize-handle bottom-right" @mousedown="startResizing(index, 'bottom-right', $event)"></div>
        </div>
        <br>
        <div>
          <q-btn v-if="!blocks1[index].hideControls" class="q-mr-md" style="background-color: white;" filled round fab-mini
            @click="increaseSize(index)">+</q-btn>
          <q-btn v-if="!blocks1[index].hideControls" class="q-mr-md" style="background-color: white;" filled round fab-mini
            @click="decreaseSize(index)">-</q-btn>
          <q-btn v-if="!blocks1[index].hideControls" class="q-mr-md" style="background-color: white;" filled round fab-mini
            @click="showRotationMenu[index] = !showRotationMenu[index]">
            <q-icon name="rotate_90_degrees_cw" />
            <q-tooltip>Rotation libre</q-tooltip>
          </q-btn>
          <div v-if="!blocks1[index].hideControls" class="rotationMenu">
            <q-menu v-model="showRotationMenu[index]">
              <q-list style="min-width: 200px">
                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Angle de rotation ({{ Math.round(blocks1[index].angle || 0) }}°)</p>
                    <q-slider 
                      label 
                      :min="0" 
                      :max="359" 
                      :step="1" 
                      v-model="blocks1[index].angle" 
                    />
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </div>
          <q-btn v-if="!blocks1[index].hideControls" class="q-mr-md" style="background-color: white;" filled round fab-mini
            @click="showBorderMenu[index] = !showBorderMenu[index]"><q-icon name="border_style" /></q-btn>
          <div v-if="!blocks1[index].hideControls" class="borderMenu">
            <q-menu v-model="showBorderMenu[index]">
              <q-list style="min-width: 200px">
                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Epaisseur de la bordure</p>
                    <q-slider label v-model="borderWidth" @change="updateBorderWidth(index)" />
                  </q-item-section>
                </q-item>

                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Couleur de la bordure</p>
                    <q-color v-model="borderColor" @change="updateBorderColor(index)" />
                  </q-item-section>
                </q-item>

                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Courbure de la bordure</p>
                    <q-slider label v-model="borderRadius" @change="updateBorderRadius(index)" />
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </div>
          <q-btn v-if="!blocks1[index].hideControls" style="background-color: white;" filled round fab-mini
            @click="showShadowMenu[index] = !showShadowMenu[index]"><q-icon name="blur_on" /></q-btn>
          <div v-if="!blocks1[index].hideControls" class="shadowMenu">
            <q-menu v-model="showShadowMenu[index]">
              <q-list style="min-width: 200px;">
                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Couleur de l'ombre</p>
                    <q-color v-model="shadowColor" @change="updateShadow(index)" />
                  </q-item-section>
                </q-item>

                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Portée X de l'ombre</p>
                    <q-slider label v-model="shadowX" @change="updateShadow(index)" />
                  </q-item-section>
                </q-item>

                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Portée Y de l'ombre</p>
                    <q-slider label v-model="shadowY" @change="updateShadow(index)" />
                  </q-item-section>
                </q-item>

                <q-item clickable v-ripple>
                  <q-item-section>
                    <p>Flou de l'ombre</p>
                    <q-slider label v-model="shadowBlur" @change="updateShadow(index)" />
                  </q-item-section>
                </q-item>


              </q-list>
            </q-menu>
          </div>
          <q-btn v-if="!blocks1[index].hideControls" class="q-mr-md" style="background-color: red;" color="white" filled round fab-mini
            @click="deleteAssociation(blocks1[index].resourceId)">
            <q-icon name="delete" style="font-size: 24px; color: red;" />            <q-tooltip>Supprimer cette ressource</q-tooltip>
          </q-btn>
          
          <!-- Bouton pour afficher/masquer les contrôles -->
          <q-btn class="q-mr-md" :color="blocks1[index].hideControls ? 'green' : 'orange'" filled round fab-mini
            @click="toggleControls(index)">
            <q-icon :name="blocks1[index].hideControls ? 'visibility' : 'visibility_off'" style="color: white;" />
            <q-tooltip>{{ blocks1[index].hideControls ? 'Afficher les contrôles' : 'Masquer les contrôles' }}</q-tooltip>
          </q-btn>
          
          <q-select v-if="!blocks1[index].hideControls" class="q-mt-md" bg-color="white" outlined :options="animationOptions" option-label="titleFr"
            option-value="title" emit-value map-options v-model="block.animation" label="Choisir une animation" dense
            @update:model-value="sendAnimation(block)" />

          <!-- Ajout des contrôles de vitesse et délai d'animation -->
          <div v-if="!blocks1[index].hideControls && block.animation" class="animation-controls q-mt-md">
            <q-select 
              bg-color="white" 
              outlined 
              :options="animationSpeedOptions" 
              option-label="label"
              option-value="value" 
              emit-value 
              map-options 
              v-model="block.animationSpeed" 
              label="Vitesse d'animation" 
              dense
              @update:model-value="sendAnimation(block)"
            />
            
            <q-select 
              class="q-mt-sm"
              bg-color="white" 
              outlined 
              :options="animationDelayOptions" 
              option-label="label"
              option-value="value" 
              emit-value 
              map-options 
              v-model="block.animationDelay" 
              label="Délai d'animation" 
              dense
              @update:model-value="sendAnimation(block)"
            />
          </div>

        </div>

      </div>

      <div v-for="(block2, index) in blocks2" :key="index">
        <div v-if="block2.text" class="block cartel" :style="{ top: block2.top + 'px', left: block2.left + 'px' }"
          @mousedown="startDragging2(index, $event)">
          {{ block2.text }}

        </div>
      </div>

    </div>
    <q-inner-loading :showing="visible" style="z-index:11000">
      <q-spinner-gears size="50px" color="primary" />
    </q-inner-loading>
    <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
      Données enregistrée
    </q-banner>
    <q-banner v-if="errorBanner" class="app-banner app-banner--error" dense rounded>
      Erreur durant l'enregistrement
    </q-banner>
    <BetweenPageLoader v-if="betweenPage" />

    <!-- Dialog pour l'éditeur de texte -->
    <q-dialog v-model="showTextEditor" persistent>
      <q-card style="width: 80vw; max-width: 800px;">
        <q-card-section class="row items-center">
          <div class="text-h6">Éditeur de texte</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="q-pb-md">
            <q-select
              v-model="selectedFont"
              :options="fontOptions"
              label="Police"
              dense
              outlined
            />
          </div>
          <div class="q-pb-md">
            <q-input 
              v-model="textFontSize" 
              type="number" 
              label="Taille (px)" 
              dense 
              outlined 
              style="width: 120px;" 
            />
          </div>
          <div class="q-pb-md">
            <q-input 
              v-model="textColor" 
              label="Couleur du texte"
              dense
              outlined
            >
              <template v-slot:append>
                <q-icon name="colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="textColor" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="q-pb-md">
            <q-input 
              v-model="textBackgroundColor" 
              label="Couleur de fond"
              dense
              outlined
            >
              <template v-slot:append>
                <q-icon name="colorize" class="cursor-pointer">
                  <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                    <q-color v-model="textBackgroundColor" />
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          
          <div class="text-editor-toolbar">
            <q-btn-group flat>
              <q-btn flat icon="format_bold" @click="formatText('bold')" />
              <q-btn flat icon="format_italic" @click="formatText('italic')" />
              <q-btn flat icon="format_underline" @click="formatText('underline')" />
              <q-btn flat icon="format_align_left" @click="formatText('justifyLeft')" />
              <q-btn flat icon="format_align_center" @click="formatText('justifyCenter')" />
              <q-btn flat icon="format_align_right" @click="formatText('justifyRight')" />
              <q-btn flat icon="format_align_justify" @click="formatText('justifyFull')" />
            </q-btn-group>
          </div>
          
          <div 
            ref="textEditor"
            class="text-editor-content" 
            contenteditable="true"
            :style="{
              fontFamily: selectedFont,
              fontSize: textFontSize + 'px',
              color: textColor,
              backgroundColor: textBackgroundColor
            }"
          ></div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Annuler" color="negative" v-close-popup />
          <q-btn flat label="Sauvegarder" color="primary" @click="saveTextBlock" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog Banque d'éléments -->
    <q-dialog v-model="showShapeBank" persistent>
      <!-- Colonne bornée : seule la liste défile, la barre « Ajouter » reste visible. -->
      <q-card class="column no-wrap" style="width: 780px; max-width: 95vw; max-height: 90vh;">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Banque d'éléments</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section class="q-pt-sm col scroll">

          <!-- FORMES GÉOMÉTRIQUES -->
          <div class="text-subtitle2 q-mb-xs" style="color: #555;">Formes géométriques</div>
          <div class="shape-bank-grid q-mb-sm">
            <div v-for="shape in shapesCatalog.filter(s => s.cat === 'geo')" :key="shape.id"
              class="shape-bank-item"
              :class="{ 'shape-bank-item--selected': selectedBankElement && selectedBankElement.id === shape.id && selectedBankElement.type === 'shape' }"
              @click="selectBankElement('shape', shape)">
              <q-icon :name="shape.icon" size="24px" />
              <div class="shape-bank-label">{{ shape.name }}</div>
            </div>
          </div>

          <!-- FLÈCHES & LIGNES -->
          <div class="text-subtitle2 q-mb-xs q-mt-sm" style="color: #555;">Flèches &amp; lignes</div>
          <div class="shape-bank-grid q-mb-sm">
            <div v-for="shape in shapesCatalog.filter(s => s.cat === 'arrow')" :key="shape.id"
              class="shape-bank-item"
              :class="{ 'shape-bank-item--selected': selectedBankElement && selectedBankElement.id === shape.id && selectedBankElement.type === 'shape' }"
              @click="selectBankElement('shape', shape)">
              <q-icon :name="shape.icon" size="24px" />
              <div class="shape-bank-label">{{ shape.name }}</div>
            </div>
          </div>

          <!-- BADGES & DÉCORATIONS -->
          <div class="text-subtitle2 q-mb-xs q-mt-sm" style="color: #555;">Badges &amp; décorations</div>
          <div class="shape-bank-grid q-mb-sm">
            <div v-for="shape in shapesCatalog.filter(s => s.cat === 'badge')" :key="shape.id"
              class="shape-bank-item"
              :class="{ 'shape-bank-item--selected': selectedBankElement && selectedBankElement.id === shape.id && selectedBankElement.type === 'shape' }"
              @click="selectBankElement('shape', shape)">
              <q-icon :name="shape.icon" size="24px" />
              <div class="shape-bank-label">{{ shape.name }}</div>
            </div>
          </div>

          <q-separator class="q-my-md" />

          <!-- ICÔNES par sous-catégories -->
          <div v-for="cat in iconCategories" :key="cat.key">
            <div class="text-subtitle2 q-mb-xs q-mt-sm" style="color: #555;">{{ cat.label }}</div>
            <div class="shape-bank-grid q-mb-sm">
              <div v-for="ico in libraryIconsCatalog.filter(i => i.cat === cat.key)" :key="ico.id"
                class="shape-bank-item"
                :class="{ 'shape-bank-item--selected': selectedBankElement && selectedBankElement.id === ico.id && selectedBankElement.type === 'icon' }"
                @click="selectBankElement('icon', ico)">
                <q-icon :name="ico.id" size="24px" />
                <div class="shape-bank-label">{{ ico.name }}</div>
              </div>
            </div>
          </div>
        </q-card-section>

        <!-- Personnalisation (sticky en bas) -->
        <q-card-section v-if="selectedBankElement" class="q-pt-none" style="border-top: 1px solid #e0e0e0; background: #fafafa;">
          <div class="text-subtitle2 q-mb-sm q-mt-sm" style="color: #555;">Personnalisation</div>
          <div class="row q-col-gutter-sm">
            <div class="col-6 col-sm-3">
              <q-input v-model="shapeFillColor" label="Remplissage" dense outlined bg-color="white">
                <template v-slot:append>
                  <q-icon name="colorize" class="cursor-pointer">
                    <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                      <q-color v-model="shapeFillColor" />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-6 col-sm-3">
              <q-input v-model="shapeStrokeColor" label="Contour" dense outlined bg-color="white">
                <template v-slot:append>
                  <q-icon name="colorize" class="cursor-pointer">
                    <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                      <q-color v-model="shapeStrokeColor" />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-6 col-sm-3">
              <q-select v-model="shapeSize" :options="shapeSizeOptions" label="Taille" dense outlined bg-color="white"
                emit-value map-options />
            </div>
            <div class="col-6 col-sm-3" v-if="selectedBankElement.type === 'shape'">
              <q-input v-model.number="shapeStrokeWidth" type="number" label="Épaisseur" dense outlined bg-color="white"
                :min="0" :max="10" />
            </div>
          </div>

          <!-- Aperçu -->
          <div class="row items-center q-mt-sm">
            <div class="shape-bank-preview-box q-mr-md">
              <div v-html="getElementPreview()" class="shape-bank-preview-content"></div>
            </div>
            <div class="text-caption" style="color: #888;">
              {{ selectedBankElement.name }}
              <span v-if="selectedBankElement.type === 'shape'"> - Forme</span>
              <span v-else> - Icône</span>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="shape-bank-actions">
          <q-btn flat label="Annuler" color="negative" v-close-popup />
          <q-btn flat label="Ajouter" color="primary" @click="addElementToCanvas" :disable="!selectedBankElement" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog pour ajouter des images -->
    <q-dialog v-model="showImageUploader" persistent>
      <!-- Colonne bornée : seule la liste des fichiers défile, la barre « Importer » reste visible. -->
      <q-card class="column no-wrap" style="width: 550px; max-width: 90vw; max-height: 90vh;">
        <q-card-section class="row items-center">
          <div class="text-h6">Ajouter des fichiers</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup :disable="uploadingFile" />
        </q-card-section>

        <q-card-section class="col scroll">
          <div
            class="drop-zone q-mb-md"
            :class="{ 'drop-zone--active': isDialogDragging }"
            @dragover.prevent="isDialogDragging = true"
            @dragenter.prevent="isDialogDragging = true"
            @dragleave.prevent="isDialogDragging = false"
            @drop.prevent="onDialogDrop"
          >
            <q-icon name="cloud_upload" size="36px" :color="isDialogDragging ? 'primary' : 'grey-6'" />
            <p class="q-mt-sm q-mb-xs text-body2">Glissez-déposez vos fichiers ici</p>
            <q-file
              v-model="uploadFileInputMulti"
              label="ou cliquez pour sélectionner"
              outlined
              dense
              multiple
              accept="image/*,video/*,audio/*,.pdf,.docx,.doc"
              @update:model-value="onUploadFilesSelected"
              style="max-width: 280px;"
            >
              <template v-slot:prepend>
                <q-icon name="attach_file" />
              </template>
            </q-file>
          </div>

          <!-- Liste des fichiers -->
          <q-list v-if="uploadFilesToProcess.length > 0" dense bordered separator class="rounded-borders q-mb-md">
            <q-item v-for="(f, idx) in uploadFilesToProcess" :key="idx">
              <q-item-section avatar>
                <q-icon :name="getUploadFileIcon(f.file.name)" />
              </q-item-section>
              <q-item-section>{{ f.file.name }}</q-item-section>
              <q-item-section side>
                <q-icon name="close" class="cursor-pointer" @click="uploadFilesToProcess.splice(idx, 1)" />
              </q-item-section>
            </q-item>
          </q-list>

          <!-- Progression -->
          <div v-if="uploadingFile">
            <div class="text-caption q-mb-xs">Fichier {{ uploadCurrentIdx }} / {{ uploadFilesToProcess.length }}</div>
            <q-linear-progress :value="uploadProgress / 100" color="blue-7" />
            <div class="text-center q-mt-xs text-caption">{{ uploadProgress }}%</div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="shape-bank-actions">
          <q-btn flat label="Annuler" color="negative" v-close-popup :disable="uploadingFile" />
          <q-btn flat label="Importer" color="primary" @click="uploadAndAddImage" :disable="uploadFilesToProcess.length === 0 || uploadingFile" :loading="uploadingFile" />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog pour sélectionner une image de fond -->
    <q-dialog v-model="showBackgroundImageSelector" persistent>
      <q-card style="width: 80vw; max-width: 800px;">
        <q-card-section class="row items-center">
          <div class="text-h6">Sélectionner une image de fond</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="row q-col-gutter-md">
            <div v-for="(resource) in allResources" :key="resource.resource_id" 
                 class="col-12 col-sm-6 col-md-4 col-lg-3">
              <q-card 
                v-if="isImage(resource.name)" 
                class="cursor-pointer bg-image-card" 
                :class="{'bg-image-selected': selectedBackgroundImage === resource.resource_id}"
                @click="selectBackgroundImage(resource)">
                <q-img 
                  :src="resource.preview || resource.imgSrc" 
                  :ratio="1"
                  style="max-height: 150px; object-fit: cover;">
                </q-img>
                <q-card-section class="q-pt-xs">
                  <div class="text-subtitle2 ellipsis">{{ resource.title || resource.name }}</div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Annuler" color="negative" v-close-popup />
          <q-btn flat label="Appliquer" color="primary" @click="applyBackgroundImage" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed, nextTick } from "vue";
import axios from "axios";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import BetweenPageLoader from "../components/BetweenPageLoader.vue";
import mammoth from 'mammoth';
import { useExhibitStyle } from "../composables/useExhibitStyle";
export default {
  components: {
    BetweenPageLoader
  },
  emits: ['closeIntermediate'],
  setup(props, { emit }) {
    const router = useRouter();
    let model = ref();
    const store = useStore();
    const name = computed(() => store.state.exhibitName);
    let options = ref([]);
    let mainResourceId = ref();
    let mainResource = ref();
    let resourcesFromPoints = ref();
    let resources = ref([]);
    let imgUrls = ref();
    const blocks1 = ref([]);
    const blocks2 = ref([]);
    let width = ref();
    let height = ref();
    var currentBlock = null;
    let startX = 0;
    let startY = 0;
    let visible = ref(false);
    var currentBlock2 = null;
    var startX2 = 0;
    var startY2 = 0;
    let success = ref(false)
    let associator = ref(false);
    const selectedPointId = computed(() => store.state.pointSelected?.point_id);
    let displayStyle = ref([]);
    const exhibitId = computed(() => store.state.exhibitId);
    const { style: charte, hasStyle: hasCharte, load: loadCharte } = useExhibitStyle(store.state.exhibitId);
    let resourceSelected = ref();
    let blocks1Opac = ref([]);
    let blocks2Opac = ref([]);
    let color = ref("#ffffff");
    let selectedAnimation = ref();
    let errorBanner = ref(false);
    let betweenPage = ref(false);
    const pointSelectedName = computed(() => store.state.pointSelected?.name);
    let titleColor = ref();
    let titleSize = ref();
    
    // Variables pour l'upload d'image
    const showImageUploader = ref(false);
    const uploadFileInputMulti = ref(null);
    const uploadFilesToProcess = ref([]);
    const uploadProgress = ref(0);
    const uploadingFile = ref(false);
    const uploadCurrentIdx = ref(0);
    const isDialogDragging = ref(false);

    // Banque d'éléments - formes et icônes
    const showShapeBank = ref(false);
    const selectedBankElement = ref(null);
    const shapeFillColor = ref('#4CAF50');
    const shapeStrokeColor = ref('#333333');
    const shapeStrokeWidth = ref(2);
    const shapeSize = ref(100);

    const shapeSizeOptions = [
      { label: 'Petit (50px)', value: 50 },
      { label: 'Moyen (100px)', value: 100 },
      { label: 'Grand (150px)', value: 150 },
      { label: 'Très grand (200px)', value: 200 }
    ];

    const shapesCatalog = [
      // Formes géométriques
      { id: 'rect', name: 'Rectangle', icon: 'crop_square', cat: 'geo' },
      { id: 'rounded-rect', name: 'Rect. arrondi', icon: 'rounded_corner', cat: 'geo' },
      { id: 'circle', name: 'Cercle', icon: 'circle', cat: 'geo' },
      { id: 'ellipse', name: 'Ellipse', icon: 'panorama_fish_eye', cat: 'geo' },
      { id: 'triangle', name: 'Triangle', icon: 'change_history', cat: 'geo' },
      { id: 'triangle-down', name: 'Triangle inv.', icon: 'signal_cellular_0_bar', cat: 'geo' },
      { id: 'diamond', name: 'Losange', icon: 'diamond', cat: 'geo' },
      { id: 'pentagon', name: 'Pentagone', icon: 'pentagon', cat: 'geo' },
      { id: 'hexagon', name: 'Hexagone', icon: 'hexagon', cat: 'geo' },
      { id: 'octagon', name: 'Octogone', icon: 'stop', cat: 'geo' },
      { id: 'cross', name: 'Croix', icon: 'add', cat: 'geo' },
      { id: 'ring', name: 'Anneau', icon: 'radio_button_unchecked', cat: 'geo' },
      { id: 'semicircle', name: 'Demi-cercle', icon: 'dark_mode', cat: 'geo' },
      { id: 'parallelogram', name: 'Parallèlo.', icon: 'filter_none', cat: 'geo' },
      { id: 'trapeze', name: 'Trapèze', icon: 'details', cat: 'geo' },
      // Flèches & lignes
      { id: 'arrow-right', name: 'Flèche →', icon: 'arrow_forward', cat: 'arrow' },
      { id: 'arrow-left', name: 'Flèche ←', icon: 'arrow_back', cat: 'arrow' },
      { id: 'arrow-up', name: 'Flèche ↑', icon: 'arrow_upward', cat: 'arrow' },
      { id: 'arrow-down', name: 'Flèche ↓', icon: 'arrow_downward', cat: 'arrow' },
      { id: 'arrow-double-h', name: 'Double ↔', icon: 'swap_horiz', cat: 'arrow' },
      { id: 'arrow-double-v', name: 'Double ↕', icon: 'swap_vert', cat: 'arrow' },
      { id: 'arrow-curved', name: 'Courbée', icon: 'redo', cat: 'arrow' },
      { id: 'chevron-right', name: 'Chevron →', icon: 'chevron_right', cat: 'arrow' },
      { id: 'chevron-left', name: 'Chevron ←', icon: 'chevron_left', cat: 'arrow' },
      { id: 'line-h', name: 'Ligne H', icon: 'horizontal_rule', cat: 'arrow' },
      { id: 'line-v', name: 'Ligne V', icon: 'more_vert', cat: 'arrow' },
      { id: 'line-diag', name: 'Diagonale', icon: 'trending_up', cat: 'arrow' },
      // Badges & décorations
      { id: 'star', name: 'Étoile', icon: 'star', cat: 'badge' },
      { id: 'star6', name: 'Étoile 6', icon: 'stars', cat: 'badge' },
      { id: 'heart', name: 'Coeur', icon: 'favorite', cat: 'badge' },
      { id: 'shield', name: 'Bouclier', icon: 'shield', cat: 'badge' },
      { id: 'ribbon', name: 'Ruban', icon: 'military_tech', cat: 'badge' },
      { id: 'badge-circle', name: 'Badge rond', icon: 'verified', cat: 'badge' },
      { id: 'cloud', name: 'Nuage', icon: 'cloud', cat: 'badge' },
      { id: 'bubble', name: 'Bulle', icon: 'chat_bubble', cat: 'badge' },
      { id: 'tag', name: 'Étiquette', icon: 'label', cat: 'badge' },
      { id: 'banner', name: 'Bannière', icon: 'flag', cat: 'badge' }
    ];

    const iconCategories = [
      { key: 'books', label: 'Livres & Lecture' },
      { key: 'culture', label: 'Culture & Patrimoine' },
      { key: 'education', label: 'Éducation & Savoir' },
      { key: 'media', label: 'Médias & Documents' },
      { key: 'navigation', label: 'Navigation & Repères' },
      { key: 'ui', label: 'Interface & Actions' },
      { key: 'people', label: 'Personnes & Social' },
      { key: 'nature', label: 'Nature & Objets' }
    ];

    const libraryIconsCatalog = [
      // Livres & Lecture
      { id: 'menu_book', name: 'Livre ouvert', cat: 'books' },
      { id: 'book', name: 'Livre', cat: 'books' },
      { id: 'library_books', name: 'Bibliothèque', cat: 'books' },
      { id: 'auto_stories', name: 'Histoires', cat: 'books' },
      { id: 'import_contacts', name: 'Pages', cat: 'books' },
      { id: 'bookmark', name: 'Marque-page', cat: 'books' },
      { id: 'bookmark_border', name: 'Marque-page vide', cat: 'books' },
      { id: 'bookmarks', name: 'Marque-pages', cat: 'books' },
      { id: 'local_library', name: 'Lecture', cat: 'books' },
      { id: 'collections_bookmark', name: 'Collection', cat: 'books' },
      { id: 'chrome_reader_mode', name: 'Mode lecture', cat: 'books' },
      { id: 'subject', name: 'Sujet', cat: 'books' },
      { id: 'class', name: 'Classe', cat: 'books' },
      // Culture & Patrimoine
      { id: 'museum', name: 'Musée', cat: 'culture' },
      { id: 'account_balance', name: 'Institution', cat: 'culture' },
      { id: 'palette', name: 'Palette', cat: 'culture' },
      { id: 'brush', name: 'Pinceau', cat: 'culture' },
      { id: 'color_lens', name: 'Couleurs', cat: 'culture' },
      { id: 'theater_comedy', name: 'Théâtre', cat: 'culture' },
      { id: 'music_note', name: 'Musique', cat: 'culture' },
      { id: 'piano', name: 'Piano', cat: 'culture' },
      { id: 'architecture', name: 'Architecture', cat: 'culture' },
      { id: 'church', name: 'Église', cat: 'culture' },
      { id: 'castle', name: 'Château', cat: 'culture' },
      { id: 'temple_hindu', name: 'Temple', cat: 'culture' },
      { id: 'fort', name: 'Fort', cat: 'culture' },
      { id: 'monument', name: 'Monument', cat: 'culture' },
      // Éducation & Savoir
      { id: 'school', name: 'École', cat: 'education' },
      { id: 'history_edu', name: 'Éducation', cat: 'education' },
      { id: 'science', name: 'Science', cat: 'education' },
      { id: 'biotech', name: 'Biotechnologie', cat: 'education' },
      { id: 'psychology', name: 'Psychologie', cat: 'education' },
      { id: 'calculate', name: 'Calcul', cat: 'education' },
      { id: 'translate', name: 'Traduction', cat: 'education' },
      { id: 'language', name: 'Langues', cat: 'education' },
      { id: 'lightbulb', name: 'Idée', cat: 'education' },
      { id: 'emoji_objects', name: 'Ampoule', cat: 'education' },
      { id: 'hub', name: 'Réseau', cat: 'education' },
      { id: 'quiz', name: 'Quiz', cat: 'education' },
      // Médias & Documents
      { id: 'article', name: 'Article', cat: 'media' },
      { id: 'newspaper', name: 'Journal', cat: 'media' },
      { id: 'feed', name: 'Fil d\'actu', cat: 'media' },
      { id: 'description', name: 'Document', cat: 'media' },
      { id: 'note', name: 'Note', cat: 'media' },
      { id: 'sticky_note_2', name: 'Post-it', cat: 'media' },
      { id: 'photo_library', name: 'Galerie', cat: 'media' },
      { id: 'image', name: 'Image', cat: 'media' },
      { id: 'photo_camera', name: 'Photo', cat: 'media' },
      { id: 'videocam', name: 'Vidéo', cat: 'media' },
      { id: 'mic', name: 'Micro', cat: 'media' },
      { id: 'headphones', name: 'Casque', cat: 'media' },
      { id: 'podcasts', name: 'Podcast', cat: 'media' },
      { id: 'qr_code_2', name: 'QR Code', cat: 'media' },
      { id: 'link', name: 'Lien', cat: 'media' },
      // Navigation & Repères
      { id: 'place', name: 'Lieu', cat: 'navigation' },
      { id: 'map', name: 'Carte', cat: 'navigation' },
      { id: 'explore', name: 'Explorer', cat: 'navigation' },
      { id: 'near_me', name: 'Proximité', cat: 'navigation' },
      { id: 'my_location', name: 'Ma position', cat: 'navigation' },
      { id: 'tour', name: 'Visite', cat: 'navigation' },
      { id: 'signpost', name: 'Panneau', cat: 'navigation' },
      { id: 'directions', name: 'Itinéraire', cat: 'navigation' },
      { id: 'flag', name: 'Drapeau', cat: 'navigation' },
      { id: 'push_pin', name: 'Épingle', cat: 'navigation' },
      { id: 'room', name: 'Repère', cat: 'navigation' },
      { id: 'where_to_vote', name: 'Destination', cat: 'navigation' },
      { id: 'navigation', name: 'Navigation', cat: 'navigation' },
      // Interface & Actions
      { id: 'info', name: 'Info', cat: 'ui' },
      { id: 'help', name: 'Aide', cat: 'ui' },
      { id: 'warning', name: 'Attention', cat: 'ui' },
      { id: 'error', name: 'Erreur', cat: 'ui' },
      { id: 'check_circle', name: 'Validé', cat: 'ui' },
      { id: 'cancel', name: 'Annuler', cat: 'ui' },
      { id: 'add_circle', name: 'Ajouter', cat: 'ui' },
      { id: 'remove_circle', name: 'Retirer', cat: 'ui' },
      { id: 'star', name: 'Étoile', cat: 'ui' },
      { id: 'star_border', name: 'Étoile vide', cat: 'ui' },
      { id: 'favorite', name: 'Favori', cat: 'ui' },
      { id: 'favorite_border', name: 'Favori vide', cat: 'ui' },
      { id: 'thumb_up', name: 'Pouce haut', cat: 'ui' },
      { id: 'thumb_down', name: 'Pouce bas', cat: 'ui' },
      { id: 'visibility', name: 'Visible', cat: 'ui' },
      { id: 'search', name: 'Recherche', cat: 'ui' },
      { id: 'tune', name: 'Réglages', cat: 'ui' },
      { id: 'touch_app', name: 'Toucher', cat: 'ui' },
      { id: 'open_in_new', name: 'Ouvrir', cat: 'ui' },
      { id: 'zoom_in', name: 'Zoom +', cat: 'ui' },
      { id: 'zoom_out', name: 'Zoom -', cat: 'ui' },
      { id: 'fullscreen', name: 'Plein écran', cat: 'ui' },
      { id: 'play_circle', name: 'Lecture', cat: 'ui' },
      { id: 'pause_circle', name: 'Pause', cat: 'ui' },
      { id: 'volume_up', name: 'Son', cat: 'ui' },
      // Personnes & Social
      { id: 'person', name: 'Personne', cat: 'people' },
      { id: 'people', name: 'Groupe', cat: 'people' },
      { id: 'groups', name: 'Foule', cat: 'people' },
      { id: 'diversity_3', name: 'Diversité', cat: 'people' },
      { id: 'face', name: 'Visage', cat: 'people' },
      { id: 'child_care', name: 'Enfant', cat: 'people' },
      { id: 'elderly', name: 'Senior', cat: 'people' },
      { id: 'accessibility_new', name: 'Accessibilité', cat: 'people' },
      { id: 'record_voice_over', name: 'Narrateur', cat: 'people' },
      { id: 'handshake', name: 'Poignée main', cat: 'people' },
      { id: 'volunteer_activism', name: 'Bénévolat', cat: 'people' },
      { id: 'emoji_events', name: 'Trophée', cat: 'people' },
      // Nature & Objets
      { id: 'park', name: 'Parc', cat: 'nature' },
      { id: 'forest', name: 'Forêt', cat: 'nature' },
      { id: 'eco', name: 'Écologie', cat: 'nature' },
      { id: 'pets', name: 'Animal', cat: 'nature' },
      { id: 'water_drop', name: 'Eau', cat: 'nature' },
      { id: 'wb_sunny', name: 'Soleil', cat: 'nature' },
      { id: 'nightlight', name: 'Lune', cat: 'nature' },
      { id: 'public', name: 'Globe', cat: 'nature' },
      { id: 'terrain', name: 'Terrain', cat: 'nature' },
      { id: 'landscape', name: 'Paysage', cat: 'nature' },
      { id: 'watch', name: 'Montre', cat: 'nature' },
      { id: 'schedule', name: 'Horloge', cat: 'nature' },
      { id: 'key', name: 'Clé', cat: 'nature' },
      { id: 'lock', name: 'Cadenas', cat: 'nature' },
      { id: 'local_cafe', name: 'Café', cat: 'nature' },
      { id: 'restaurant', name: 'Restaurant', cat: 'nature' },
      { id: 'cake', name: 'Gâteau', cat: 'nature' },
      { id: 'celebration', name: 'Fête', cat: 'nature' },
      { id: 'home', name: 'Maison', cat: 'nature' },
      { id: 'storefront', name: 'Boutique', cat: 'nature' }
    ];

    // Variables pour les textes personnalisés
    const textBlocks = ref([]);
    const showTextEditor = ref(false);
    const editingTextIndex = ref(-1);
    const textEditor = ref(null);
    const selectedFont = ref('Arial');
    const textFontSize = ref(16);
    const textColor = ref('#000000');
    const textBackgroundColor = ref('transparent');
    
    // Variables pour le style des textes
    const showTextBorderMenu = ref([]);
    const textBorderWidth = ref(1);
    const textBorderColor = ref('#000000');
    const textBorderRadius = ref(0);
    const showTextShadowMenu = ref([]);
    const textShadowColor = ref('#000000');
    const textShadowX = ref(0);
    const textShadowY = ref(0);
    const textShadowBlur = ref(5);
    
    // Variables pour le texte en cours de déplacement
    const currentTextBlock = ref(null);
    const startTextX = ref(0);
    const startTextY = ref(0);
    
    // Options de police
    const fontOptions = [
      'Arial', 'Verdana', 'Helvetica', 'Times New Roman', 'Courier New', 
      'Georgia', 'Palatino', 'Garamond', 'Bookman', 'Tahoma', 'Trebuchet MS'
    ];
    
    var animationOptions = ref([
      { "title": null, "titleFr": "Aucune Animation" },
      { "title": "squareImg", "titleFr": "Affichage progressif en carrés" },
      { "title": "heartBeat", "titleFr": "Battement de Cœur" },
      { "title": "bounceIn", "titleFr": "Rebond Entrant" },
      { "title": "bounce", "titleFr": "Rebond" },
      { "title": "swingRotate", "titleFr": "Demi rotation infinie" },
      { "title": "hinge", "titleFr": "Charnière" },
      { "title": "jackInTheBox", "titleFr": "Diable en Boîte" },
      { "title": "jello", "titleFr": "Gelée" },
      { "title": "musicNote", "titleFr": "Note de musique" },
      { "title": "pulse", "titleFr": "Pulsation infinie" },
      { "title": "spin", "titleFr": "Rotation infinie" },
      { "title": "rotateInDownLeft", "titleFr": "Rotation Descendante Gauche" },
      { "title": "rotateInDownRight", "titleFr": "Rotation Descendante Droite" },
      { "title": "rotateIn", "titleFr": "Rotation Entrante" },
      { "title": "rotateInUpLeft", "titleFr": "Rotation Ascendante Gauche" },
      { "title": "rotateInUpRight", "titleFr": "Rotation Ascendante Droite" },
      { "title": "rollIn", "titleFr": "Roulement Entrant" },
      { "title": "rubberBand", "titleFr": "Bande Élastique" },
      { "title": "pulse", "titleFr": "Pulsation" },
      { "title": "headShake", "titleFr": "Secousse de Tête" },
      { "title": "shakeX", "titleFr": "Secousse Horizontale" },
      { "title": "shakeY", "titleFr": "Secousse Verticale" },
      { "title": "slide", "titleFr": "Translation infinie" },
      { "title": "verticalBounce", "titleFr": "Translation verticale infinie" },
      { "title": "slideInDown", "titleFr": "Glissement Descendant Entrant" },
      { "title": "slideInLeft", "titleFr": "Glissement Gauche Entrant" },
      { "title": "slideInRight", "titleFr": "Glissement Droit Entrant" },
      { "title": "slideInUp", "titleFr": "Glissement Ascendant Entrant" },
      { "title": "swing", "titleFr": "Balancement" },
      { "title": "tada", "titleFr": "Tada" },
      { "title": "wobble", "titleFr": "Vacillement" },
      { "title": "fadeIn", "titleFr": "Apparition Progressive" },
      { "title": "flash", "titleFr": "Flash" },
      { "title": "flipInX", "titleFr": "Pivot Horizontal Entrant" },
      { "title": "flipInY", "titleFr": "Pivot Vertical Entrant" },
      { "title": "lightSpeedInLeft", "titleFr": "Éclair Rapide Gauche" },
      { "title": "lightSpeedInRight", "titleFr": "Éclair Rapide Droit" },
      { "title": "zoomInDown", "titleFr": "Zoom Avant Descendant" },
      { "title": "zoomInLeft", "titleFr": "Zoom Avant Gauche" },
      { "title": "zoomIn", "titleFr": "Zoom Avant" },
      { "title": "zoomInRight", "titleFr": "Zoom Avant Droit" },
      { "title": "zoomInUp", "titleFr": "Zoom Avant Ascendant" },
    ]);

    // Options pour les vitesses d'animation
    const animationSpeedOptions = [
      { value: "", label: "Normale (1s)" },
      { value: "animate__slower", label: "Très lente (3s)" },
      { value: "animate__slow", label: "Lente (2s)" },
      { value: "animate__fast", label: "Rapide (800ms)" },
      { value: "animate__faster", label: "Très rapide (500ms)" }
    ];
    
    // Options pour les délais d'animation
    const animationDelayOptions = [
      { value: "", label: "Sans délai" },
      { value: "animate__delay-1s", label: "Délai de 1s" },
      { value: "animate__delay-2s", label: "Délai de 2s" },
      { value: "animate__delay-3s", label: "Délai de 3s" },
      { value: "animate__delay-4s", label: "Délai de 4s" },
      { value: "animate__delay-5s", label: "Délai de 5s" }
    ];
    
    // Options pour les répétitions d'animation
    const animationRepeatOptions = [
      { value: "", label: "Une seule fois" },
      { value: "animate__repeat-2", label: "2 répétitions" },
      { value: "animate__repeat-3", label: "3 répétitions" },
      { value: "animate__infinite", label: "Infini" }
    ];

    const filteredBlocks2 = computed(() => blocks2.value.filter(block => block.text !== 'undefined' && block.text !== null && block.text !== ""));
    const showBorderMenu = ref([]);
    const borderWidth = ref(0); // pas de bordure par défaut
    const borderColor = ref("#000000"); // noir par défaut
    const borderRadius = ref(0); // pas d'arrondi par défaut
    const showShadowMenu = ref([]);
    const shadowColor = ref('#000');
    const shadowX = ref(0);
    const shadowY = ref(0);
    const shadowBlur = ref(5);
    const showRotationMenu = ref([]);

    let isResizing = false;
    let resizingBlock = null;
    let resizeHandle = null;
    let startWidth = 0;
    let startHeight = 0;
    let startTop = 0;
    let startLeft = 0;
    let startMouseX = 0;
    let startMouseY = 0;
    
    // Variables pour le redimensionnement des blocs de texte
    let isResizingText = false;
    let resizingTextBlock = null;
    let textResizeHandle = null;
    let textStartWidth = 0;
    let textStartHeight = 0;
    let textStartTop = 0;
    let textStartLeft = 0;
    let textStartMouseX = 0;
    let textStartMouseY = 0;
    
    const startResizing = (index, handle, event) => {
      event.preventDefault();
      event.stopPropagation(); // Empêcher la propagation pour éviter de démarrer le déplacement

      isResizing = true;
      resizingBlock = blocks1.value[index];
      resizeHandle = handle;
      
      // Enregistrer les dimensions et positions initiales
      startWidth = resizingBlock.width;
      startHeight = resizingBlock.height;
      startTop = resizingBlock.top;
      startLeft = resizingBlock.left;
      
      startMouseX = event.clientX;
      startMouseY = event.clientY;

      document.addEventListener("mousemove", handleResizeMove);
      document.addEventListener("mouseup", stopResizing);
    };

    const handleResizeMove = (event) => {
      if (!isResizing || !resizingBlock) return;

      // Déplacement de la souris depuis le début du redimensionnement
      const mouseX = event.clientX;
      const mouseY = event.clientY;
      
      // Calculer les dimensions minimales
      const minWidth = 50;
      const minHeight = 50;
      
      // Variables pour stocker les calculs temporaires
      let newWidth, newHeight;
      
      // Redimensionnement basé sur la poignée utilisée
      switch (resizeHandle) {
        case 'bottom-right':
          // Pour bottom-right, le point d'ancrage est top-left (ne change pas)
          resizingBlock.width = Math.max(minWidth, startWidth + (mouseX - startMouseX));
          resizingBlock.height = Math.max(minHeight, startHeight + (mouseY - startMouseY));
          break;
          
        case 'bottom-left':
          // Pour bottom-left, le point d'ancrage est top-right
          newWidth = Math.max(minWidth, startWidth - (mouseX - startMouseX));
          resizingBlock.height = Math.max(minHeight, startHeight + (mouseY - startMouseY));
          
          // Ajuster la position de gauche pour maintenir le côté droit fixe
          resizingBlock.left = startLeft + startWidth - newWidth;
          resizingBlock.width = newWidth;
          break;
          
        case 'top-right':
          // Pour top-right, le point d'ancrage est bottom-left
          resizingBlock.width = Math.max(minWidth, startWidth + (mouseX - startMouseX));
          newHeight = Math.max(minHeight, startHeight - (mouseY - startMouseY));
          
          // Ajuster la position du haut pour maintenir le bas fixe
          resizingBlock.top = startTop + startHeight - newHeight;
          resizingBlock.height = newHeight;
          break;
          
        case 'top-left':
          // Pour top-left, le point d'ancrage est bottom-right
          newWidth = Math.max(minWidth, startWidth - (mouseX - startMouseX));
          newHeight = Math.max(minHeight, startHeight - (mouseY - startMouseY));
          
          // Ajuster les positions pour maintenir le coin bottom-right fixe
          resizingBlock.left = startLeft + startWidth - newWidth;
          resizingBlock.top = startTop + startHeight - newHeight;
          resizingBlock.width = newWidth;
          resizingBlock.height = newHeight;
          break;
      }
    };

    const stopResizing = () => {
      isResizing = false;
      resizingBlock = null;
      document.removeEventListener("mousemove", handleResizeMove);
      document.removeEventListener("mouseup", stopResizing);
    };

    // Fonctions de redimensionnement pour les blocs de texte
    const startResizingText = (index, handle, event) => {
      event.preventDefault();
      event.stopPropagation();

      isResizingText = true;
      resizingTextBlock = textBlocks.value[index];
      textResizeHandle = handle;
      
      // Enregistrer les dimensions et positions initiales avec validation
      const initialDimensions = validateDimensions(resizingTextBlock.width, resizingTextBlock.height);
      textStartWidth = initialDimensions.width;
      textStartHeight = initialDimensions.height;
      textStartTop = resizingTextBlock.top;
      textStartLeft = resizingTextBlock.left;
      

      
      textStartMouseX = event.clientX;
      textStartMouseY = event.clientY;

      document.addEventListener("mousemove", handleTextResizeMove);
      document.addEventListener("mouseup", stopResizingText);
    };

    const handleTextResizeMove = (event) => {
      if (!isResizingText || !resizingTextBlock) return;

      const mouseX = event.clientX;
      const mouseY = event.clientY;
      
      const minWidth = 50;
      const minHeight = 30;
      
      let newWidth, newHeight;
      
      switch (textResizeHandle) {
        case 'bottom-right':
          resizingTextBlock.width = Math.max(minWidth, textStartWidth + (mouseX - textStartMouseX));
          resizingTextBlock.height = Math.max(minHeight, textStartHeight + (mouseY - textStartMouseY));
          break;
           
        case 'bottom-left':
          newWidth = Math.max(minWidth, textStartWidth - (mouseX - textStartMouseX));
          resizingTextBlock.height = Math.max(minHeight, textStartHeight + (mouseY - textStartMouseY));
          resizingTextBlock.left = textStartLeft + textStartWidth - newWidth;
          resizingTextBlock.width = newWidth;
          break;
          
        case 'top-right':
          resizingTextBlock.width = Math.max(minWidth, textStartWidth + (mouseX - textStartMouseX));
          newHeight = Math.max(minHeight, textStartHeight - (mouseY - textStartMouseY));
          resizingTextBlock.top = textStartTop + textStartHeight - newHeight;
          resizingTextBlock.height = newHeight;
          break;
          
        case 'top-left':
          newWidth = Math.max(minWidth, textStartWidth - (mouseX - textStartMouseX));
          newHeight = Math.max(minHeight, textStartHeight - (mouseY - textStartMouseY));
          resizingTextBlock.left = textStartLeft + textStartWidth - newWidth;
          resizingTextBlock.top = textStartTop + textStartHeight - newHeight;
          resizingTextBlock.width = newWidth;
          resizingTextBlock.height = newHeight;
          break;
      }
    };

    const stopResizingText = async () => {
      isResizingText = false;
      resizingTextBlock = null;
      document.removeEventListener("mousemove", handleTextResizeMove);
      document.removeEventListener("mouseup", stopResizingText);
      
      // Sauvegarder automatiquement après redimensionnement
      try {
        await saveCustomTexts();
      } catch (error) {
        console.error('Erreur lors de la sauvegarde après redimensionnement:', error);
      }
    };



    const start = async () => {
      visible.value = true; // Afficher le loader pendant le chargement
      
      try {
        await loadCharte();
        // Première étape : charger les ressources principales
        await getMainResource();
        await getResourcesFromPoints();
        await getAllResources(); // Charger toutes les ressources pour le sélecteur d'images
        
        // Deuxième étape : traiter les ressources et charger les configurations
        await handleSelect();
        await fetchPointColors();
        await fetchAnimations();
        await loadSavedTexts(); // Charger les textes personnalisés
        
        // Troisième étape : charger l'image de fond (après que getAllResources soit terminé)
        await loadBackgroundImage();
      } catch (error) {
        console.error("Erreur lors du démarrage:", error);
        errorBanner.value = true;
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500);
      } finally {
        visible.value = false; // Cacher le loader quoi qu'il arrive
      }
    };

    const startDragging = (index, event) => {
      event.preventDefault();
      currentBlock = blocks1.value[index];
      startX = event.clientX;
      startY = event.clientY;

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", stopDragging);
      document.addEventListener("touchmove", handleMouseMove, { passive: false });
      document.addEventListener("touchup", stopDragging, { passive: false });
    };

    const startDragging2 = (index, event) => {
      event.preventDefault();
      currentBlock2 = blocks2.value[index];
      startX2 = event.clientX;
      startY2 = event.clientY;
      document.addEventListener("mousemove", handleMouseMove2);
      document.addEventListener("mouseup", stopDragging2);
    };

    const handleMouseMove = (event) => {
      event.preventDefault();
      if (!currentBlock) return;
      event.preventDefault();
      const diffX = event.clientX - startX;
      const diffY = event.clientY - startY;

      currentBlock.left += diffX;
      currentBlock.top += diffY;

      startX = event.clientX;
      startY = event.clientY;
    };
    const increaseSize = (index) => {
      if (blocks1.value[index].width <= 0 || blocks1.value[index].height <= 0)
        return;

      const aspectRatio =
        blocks1.value[index].width / blocks1.value[index].height;
      blocks1.value[index].width += 10;
      blocks1.value[index].height = blocks1.value[index].width / aspectRatio;

      if (blocks1.value[index].height <= 0) {
        blocks1.value[index].height = 10;
        blocks1.value[index].width = blocks1.value[index].height * aspectRatio;
      }
    };

    const rotateImage = (index) => {
      // Vérifiez si l'objet de l'index spécifié existe
      if (!blocks1.value[index]) return;

      // Initialise l'angle de rotation si ce n'est pas déjà fait
      if (!blocks1.value[index].angle) {
        blocks1.value[index].angle = 0;
      }

      // Augmentez l'angle de rotation de 90 degrés
      blocks1.value[index].angle += 90;

      // Réinitialisez à 0 si l'angle atteint 360
      if (blocks1.value[index].angle >= 360) {
        blocks1.value[index].angle = 0;
      }
    };


    const getRotationStyle = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        boxShadow: block.boxShadow
      };
    };

    const getRotationStyleVideo = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        objectFit: 'contain',
        width: `${block.width}px`,
        height: `${block.height}px`,
        boxShadow: block.boxShadow

      };
    };

    const getTitleStyle = () => {
      return {
        marginBottom: 'none',
        textAlign: 'center',
        color: titleColor.value,
        fontSize: titleSize.value + "px"
      }
    }


    const decreaseSize = (index) => {
      if (blocks1.value[index].width <= 0 || blocks1.value[index].height <= 0)
        return;

      const aspectRatio =
        blocks1.value[index].width / blocks1.value[index].height;
      blocks1.value[index].width -= 10;
      blocks1.value[index].height = blocks1.value[index].width / aspectRatio;

      if (blocks1.value[index].height <= 0) {
        blocks1.value[index].height = 10;
        blocks1.value[index].width = blocks1.value[index].height * aspectRatio;
      }
    };

    const fetchAnimations = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/animations`;
        let response = await axios.get(url);
        let animations = response.data;
        animations.forEach(animation => {
          // Trouvez l'index du block avec le resourceId correspondant          
          const blockIndex = blocks1.value.findIndex(block => block.resourceId == animation.resource_id && animation.point_id == selectedPointId.value);
          if (blockIndex !== -1) {
            blocks1.value[blockIndex]['animation'] = animation.animation;
            blocks1.value[blockIndex]['animationSpeed'] = animation.speed || "";
            blocks1.value[blockIndex]['animationDelay'] = animation.delay || "";
          }
        });
      } catch (error) {
        console.log(error);
      }
    }


    const handleMouseMove2 = (event2) => {
      event2.preventDefault();
      if (!currentBlock2) return;
      event2.preventDefault();
      const diffX = event2.clientX - startX2;
      const diffY = event2.clientY - startY2;

      currentBlock2.left += diffX;
      currentBlock2.top += diffY;

      startX2 = event2.clientX;
      startY2 = event2.clientY;
    };

    const getMainResource = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/mainresource/${store.state.exhibitId}`;
        let response = await axios.get(url);
        //Récupération de l'id de la page principale
        mainResourceId.value = response.data[0].main_resource_id;
        mainResource.value = response.data[0];
      } catch (error) {
        console.log(error);
      }
    };





    const getResourcesFromPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resourcesFromPointwithAssociations/${store.state.pointSelected.point_id}`;
        let response = await axios.get(url);
        resources.value = response.data;
      } catch (error) {
        console.log(error);
      }
    }





    const handleSelect = async () => {
      blocks1.value = [];
      blocks2.value = [];
      const { marginLeft, marginTop } = computeMargins();
      console.log("marginLeft", marginLeft)
      console.log("marginTop", marginTop)
      const MAX_WIDTH = 800; // Largeur maximale souhaitée
      const MAX_HEIGHT = 600; // Hauteur maximale souhaitée
      let filteredData = resources.value;
      for (var data of filteredData) {
        visible.value = true;
        showBorderMenu.value.push(false);
        showShadowMenu.value.push(false);
        showRotationMenu.value.push(false);
        let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${data.name}`;
        let response = await axios.get(url);
        console.log("resource", response.data)
        let url2 = `${process.env.VUE_APP_BASEURL}/position/${data.resource_id}`
        let position = await axios.get(url2);
        console.log("position", position.data)
        console.log("marginLeft", marginLeft)
        console.log("marginTop", marginTop)
        if (position.data.length > 1) {
          position.data = position.data.filter(element => element.point_id == store.state.pointSelected.point_id)
        }
        const base64data = response.data;
        const imageDimensions = await getResourceDetails(base64data);

        var obj = {};
        obj.resourceId = data.resource_id;
        obj.name = data.name;
        obj.title = data.title;
        obj.top = position.data[0] ? position.data[0].y : Math.floor(Math.random() * (400 - 0 + 1)) + 0;
        obj.left = position.data[0] ? position.data[0].x  : Math.floor(Math.random() * (800 - 0 + 1)) + 0;
        if (isPdf(data.name)) {
          obj.width = 400;
          obj.height = 600;
        } else {
          obj.width = position.data[0] && position.data[0].width != null ? position.data[0].width : imageDimensions.width;
          obj.height = position.data[0] && position.data[0].height != null ? position.data[0].height : imageDimensions.height;
          // Appliquer une limite de taille
          if (obj.width > MAX_WIDTH) {
            // Calculer le ratio pour maintenir l'aspect de l'image
            const ratio = MAX_WIDTH / obj.width;
            obj.width = MAX_WIDTH;
            obj.height *= ratio; // Ajuster la hauteur en fonction du nouveau ratio
          }

          if (obj.height > MAX_HEIGHT) {
            // Calculer le ratio pour maintenir l'aspect de l'image
            const ratio = MAX_HEIGHT / obj.height;
            obj.height = MAX_HEIGHT;
            obj.width *= ratio; // Ajuster la largeur en fonction du nouveau ratio
          }
        }
        obj.imgSrc = base64data;
        obj.angle = position.data[0] ? position.data[0].angle : 0;
        obj.radius = position.data[0] ? position.data[0].border_radius : 10;
        obj.borderColor = position.data[0] ? position.data[0].border_color : "#ffffff";
        // Pas de bordure par défaut : une image fraîchement posée n'en a pas,
        // on en ajoute une au curseur si on le souhaite.
        obj.borderWidth = position.data[0] ? position.data[0].border_width : 0;
        obj.boxShadow = position.data[0] ? position.data[0].shadow : "0px 0px 0px #000000";
        obj.hideControls = false; // Initialiser la propriété hideControls
        
        // Si c'est un document DOCX, convertir le contenu avec mammoth
        if (isDocx(data.name)) {
          try {
            console.log("Traitement d'un fichier DOCX:", data.name);
            
            // Si l'URL est une URL S3 directe (avec paramètres d'authentification)
            if (base64data.startsWith('http')) {
              try {
                // Au lieu d'appeler directement l'URL S3 (qui provoque l'erreur CORS),
                // nous allons utiliser notre propre API comme proxy
                const resourceName = data.name;
                const proxyUrl = `${process.env.VUE_APP_BASEURL}/proxy-document?url=${encodeURIComponent(base64data)}`;
                
                console.log("Utilisation du proxy pour récupérer le document:", resourceName);
                
                // Définir une option de secours au cas où le proxy ne serait pas disponible
                obj.docContent = `
                  <div style="padding: 20px; background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 5px;">
                    <h3>Chargement du document DOCX...</h3>
                    <p>Tentative de chargement du document via le serveur proxy.</p>
                    <p>Si le document ne s'affiche pas, vous pourrez le télécharger en cliquant sur le lien ci-dessous.</p>
                    <div style="text-align: center; margin-top: 15px;">
                      <a href="${base64data}" 
                         download="${data.name}" 
                         style="background-color: #4285f4; color: white; padding: 10px 15px; text-decoration: none; border-radius: 4px; font-weight: bold;">
                        Télécharger le document
                      </a>
                    </div>
                  </div>
                `;
                
                // Ajouter le document aux blocs mais continuer le chargement
                blocks1.value.push(obj);
                
                try {
                  // Essayer de récupérer le contenu via le proxy
                  const response = await axios.get(proxyUrl, { responseType: 'arraybuffer' });
                  
                  // Convertir le contenu avec Mammoth
                  const result = await mammoth.convertToHtml({ arrayBuffer: response.data });
                  
                  // Mettre à jour le contenu du document
                  const index = blocks1.value.findIndex(block => block.resourceId === obj.resourceId);
                  if (index !== -1 && result.value) {
                    blocks1.value[index].docContent = result.value;
                    console.log('Document DOCX converti avec succès via proxy');
                  }
                } catch (innerError) {
                  console.error('Erreur avec le proxy:', innerError);
                  // Le message par défaut est déjà défini, continuer
                }
                
                // Ne pas ajouter à nouveau l'objet puisqu'il a déjà été ajouté
                continue;
              } catch (proxyError) {
                console.error('Erreur avec le proxy:', proxyError);
                
                // En cas d'échec, nous utilisons déjà l'option de secours définie ci-dessus
                // mais nous nous assurons d'ajouter l'objet avec l'option de secours
                blocks1.value.push(obj);
                continue;
              }
            } 
            else {
              // Traitement comme contenu base64 (inchangé)
              let dataUrl = base64data;
              
              // Si ce n'est pas une URL de données, en créer une
              if (!base64data.startsWith('data:')) {
                // Créer un type MIME approprié pour les documents Office
                const mimeType = data.name.endsWith('.docx') 
                  ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                  : 'application/msword';
                
                // Préfixer avec l'en-tête data: et le type MIME
                dataUrl = `data:${mimeType};base64,${base64data}`;
              }
              
              // Utiliser fetch pour traiter l'URL de données
              const response = await fetch(dataUrl);
              const blob = await response.blob();
              const arrayBuffer = await blob.arrayBuffer();
              
              // Convertir le document avec Mammoth
              const result = await mammoth.convertToHtml({ arrayBuffer });
              obj.docContent = result.value || '<p>Document vide</p>';
              
              console.log('Document DOCX converti avec succès');
            }
          } catch (error) {
            console.error('Erreur générale:', error);
            obj.docContent = `<p>Une erreur s'est produite lors du traitement: ${error.message}</p>`;
            // S'assurer que l'objet est ajouté même en cas d'erreur
            blocks1.value.push(obj);
            continue;
          }
        }
        
        // N'ajouter l'objet aux blocs que s'il n'a pas déjà été ajouté (cas des URLs)
        if (!isDocx(data.name) || !base64data.startsWith('http')) {
          blocks1.value.push(obj);
        }
        
        // S'assurer que le loader est caché à chaque itération
        visible.value = false;
      }
      
      // S'assurer que le loader est caché à la fin de la fonction
      visible.value = false;
      
      for (var data2 of filteredData) {
        let url3 = `${process.env.VUE_APP_BASEURL}/position/${data2.resource_id}`
        let position2 = await axios.get(url3);
        if (position2.data.length > 1) {
          position2.data = position2.data.filter(element => element.point_id == store.state.pointSelected.point_id)
        }
        var obj2 = {};
        obj2.resourceId = data2.resource_id;
        obj2.top = position2.data[0] ? position2.data[0].description_y + marginTop : Math.floor(Math.random() * (400 - 0 + 1)) + 0;
        obj2.left = position2.data[0] ? position2.data[0].description_x + marginLeft : Math.floor(Math.random() * (800 - 0 + 1)) + 0;
        obj2.text = data2.description;
        blocks2.value.push(obj2);
      }
    };


    function getResourceDetails(url) {
      return new Promise((resolve) => {
        // Vérifier d'abord l'extension du fichier pour déterminer son type
        const urlString = typeof url === 'string' ? url : '';
        const extension = urlString.split('.').pop()?.toLowerCase() || '';
        
        // Pour les documents, définir directement une taille par défaut sans tenter de charger
        if (["docx", "doc"].includes(extension)) {
          resolve({ type: 'document', width: 600, height: 800 });
          return;
        }

        // Pour les fichiers PDF, définir une taille standard
        if (extension === 'pdf') {
          resolve({ type: 'pdf', width: 400, height: 600 });
          return;
        }
        
        // Pour les autres types, tenter de charger comme avant
        let img = new Image();
        img.onload = () => {
          resolve({ type: 'image', width: img.width, height: img.height });
        };
        img.onerror = () => {
          // Si ce n'est pas une image, essayez de charger comme une vidéo
          let video = document.createElement('video');
          video.onloadedmetadata = () => {
            resolve({ type: 'video', width: video.videoWidth, height: video.videoHeight, duration: video.duration });
          };
          video.onerror = () => {
            // Si ce n'est pas une vidéo, essayez de charger comme un audio
            let audio = new Audio();
            audio.onloadedmetadata = () => {
              resolve({ type: 'audio', duration: audio.duration });
            };
            audio.onerror = () => {
              // Si tous les essais échouent, utiliser une taille par défaut pour éviter l'erreur
              resolve({ type: 'unknown', width: 300, height: 200 });
            };
            audio.src = url;
          };
          video.src = url;
        };
        img.src = url;
      });
    }



    const back = () => {
      emit('closeIntermediate');
    }

    const scrollToTop = () => {
      window.scrollTo(0, 0);
    }


    const stopDragging = () => {
      
      currentBlock = null;
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopDragging);
    };

    const stopDragging2 = () => {
      currentBlock2 = null;
      document.removeEventListener("mousemove", handleMouseMove2);
      document.removeEventListener("mouseup", stopDragging2);
    };

    const computeMargins = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const marginLeft = (windowWidth - 1400) / 2;
      const marginTop = (windowHeight - 1200) /2;

      return { marginLeft, marginTop };
    }

    const updateBorderRadius = (index) => {
      blocks1.value[index].radius = borderRadius.value;
    }

    const updateBorderWidth = (index) => {
      blocks1.value[index].borderWidth = borderWidth.value;

    }

    const updateBorderColor = (index) => {
      blocks1.value[index].borderColor = borderColor.value;

    }

    const updateShadow = (index) => {
      let shadowStyle = `${shadowX.value}px ${shadowY.value}px ${shadowBlur.value}px ${shadowColor.value}`;
      updateBlockStyle(index, 'boxShadow', shadowStyle);
    };

    const updateBlockStyle = (index, styleProperty, styleValue) => {
      if (blocks1.value[index]) {
        if (!blocks1.value[index][styleProperty]) {
          blocks1.value[index][styleProperty] = {};
        }
        blocks1.value[index][styleProperty] = styleValue;
      }
    };


    const save = async () => {
      try {
        const { marginLeft, marginTop } = computeMargins();
        console.log("marginLeft", marginLeft)
        console.log("marginTop", marginTop)
        await saveBackgroundColor();
        await saveCustomTexts(); // Sauvegarder les textes personnalisés
        
        const requests = blocks1.value.map((element, index) => {
          let url = `${process.env.VUE_APP_BASEURL}/position`;
          let body = {
            resourceId: element.resourceId,
            x: element.left,
            y: element.top,
            x2: blocks2.value[index]?.left,
            y2: blocks2.value[index]?.top,
            width: element.width,
            height: element.height,
            point_id: store.state.pointSelected.point_id,
            angle: element.angle,
            border_radius: element.radius,
            border_color: element.borderColor,
            border_width: element.borderWidth,
            shadow: element.boxShadow
          };
          return axios.post(url, body);
        });

        await Promise.all(requests);

        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
        setTimeout(async () => {
          betweenPage.value = true;
          setTimeout(() => {
            router.push({ path: `/associationManagement` });
          }, 3000)
        }, 1600);

      } catch (error) {
        console.log(error);
        errorBanner.value = true
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500)
      }
    };

    const saveAll = async () => {
      try {
        const { marginLeft, marginTop } = computeMargins();
        console.log("marginLeft", marginLeft)
        console.log("marginTop", marginTop)
        await saveBackgroundColor();
        await saveCustomTexts(); // Sauvegarder les textes personnalisés
        
        const requests = blocks1.value.map((element, index) => {
          let url = `${process.env.VUE_APP_BASEURL}/position`;
          let body = {
            resourceId: element.resourceId,
            x: element.left,
            y: element.top,
            x2: blocks2.value[index]?.left,
            y2: blocks2.value[index]?.top,
            width: element.width,
            height: element.height,
            point_id: store.state.pointSelected.point_id,
            angle: element.angle,
            border_radius: element.radius,
            border_color: element.borderColor,
            border_width: element.borderWidth,
            shadow: element.boxShadow
          };
          return axios.post(url, body);
        });

        await Promise.all(requests);
      
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
        

      } catch (error) {
        console.log(error);
        errorBanner.value = true
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500)
      }
    };

    const saveTitleParams = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/pointTitleParameters`;
        let putBody = {
          pointId: selectedPointId.value,
          textColor: titleColor.value,
          textSize: titleSize.value,
        }
        await axios.put(url, putBody);
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
      } catch (error) {
        console.log(error);
        errorBanner.value = true
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500)
      }
    }


    function isImage(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }

    function isVideo(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp4", "webm", "avi", "mov", "mkv"].includes(extension);
    }

    function isAudio(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp3", "wav", "ogg", "m4a"].includes(extension);
    }

    function isPdf(filename) {
      return filename.toLowerCase().endsWith('.pdf');
    }
    
    function isDocx(filename) {
      const extension = filename.split(".").pop().toLowerCase();
      return ["docx", "doc"].includes(extension);
    }

    const saveBackgroundColor = async () => {
      try {
        let encodedColor = encodeURIComponent(color.value);
        let url = `${process.env.VUE_APP_BASEURL}/intermediateColor/${selectedPointId.value}/${encodedColor}`;
        await axios.put(url);
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchPointColors = async () => {
      const fallbackBg = hasCharte.value ? charte.value.bg_color : "#ffffff";
      try {
        let url = `${process.env.VUE_APP_BASEURL}/intermediateColor/${selectedPointId.value}`;
        let response = await axios.get(url);
        color.value = response.data[0].background_color || fallbackBg;
        titleColor.value = response.data[0].text_color;
        titleSize.value = response.data[0].text_size;
      } catch (error) {
        console.log(error);
      }
    }

    const sendAnimation = async (block) => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resource_animation`;
        let postBody = {
          "resourceId": block.resourceId,
          "animation": block.animation,
          "pointId": selectedPointId.value,
          "speed": block.animationSpeed || "",
          "delay": block.animationDelay || ""
        }
        let response = await axios.post(url, postBody);

        if (response.status == 200) {
          success.value = true;
          
          // Prévisualiser l'animation
          previewAnimation(block);
          
          setTimeout(() => {
            success.value = false;
          }, 1500);
        }
      } catch (error) {
        console.log(error);
        errorBanner.value = true;
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500);
      }
    }

    const previewAnimation = (block) => {
      // On utilise une approche simple : on retire et réapplique la classe d'animation
      // pour réinitialiser l'animation
      const blockIndex = blocks1.value.findIndex(b => b.resourceId === block.resourceId);
      if (blockIndex !== -1) {
        // On sauvegarde les classes d'animation
        const animation = blocks1.value[blockIndex].animation;
        const speed = blocks1.value[blockIndex].animationSpeed;
        const delay = blocks1.value[blockIndex].animationDelay;
        
        // On retire temporairement l'animation
        blocks1.value[blockIndex].animation = null;
        
        // On rétablit l'animation après un bref délai pour forcer le navigateur à la rejouer
        setTimeout(() => {
          blocks1.value[blockIndex].animation = animation;
          blocks1.value[blockIndex].animationSpeed = speed;
          blocks1.value[blockIndex].animationDelay = delay;
        }, 10);
      }
    }

    const getTextBlockContentStyle = (textBlock) => {
      return {
        fontFamily: textBlock.fontFamily || (hasCharte.value ? charte.value.text_font : 'Arial'),
        fontSize: (textBlock.fontSize || (hasCharte.value ? charte.value.text_size : 16)) + 'px',
        color: textBlock.color || (hasCharte.value ? charte.value.text_color : '#000000'),
        backgroundColor: textBlock.backgroundColor || 'transparent',
        borderWidth: textBlock.borderWidth + 'px',
        borderStyle: textBlock.borderStyle,
        borderColor: textBlock.borderColor,
        borderRadius: textBlock.borderRadius + 'px',
        boxShadow: textBlock.boxShadow,
        padding: '10px',
        width: textBlock.width + 'px',
        height: textBlock.height + 'px',
        minWidth: '50px',
        minHeight: '30px',
        cursor: 'move',
        userSelect: 'none',
        display: 'inline-block',
        overflow: 'auto',
        wordWrap: 'break-word'
      };
    };
    
    const startDraggingText = (index, event) => {
      event.preventDefault();
      currentTextBlock.value = textBlocks.value[index];
      startTextX.value = event.clientX;
      startTextY.value = event.clientY;
      
      document.addEventListener("mousemove", handleTextMouseMove);
      document.addEventListener("mouseup", stopDraggingText);
    };
    
    const handleTextMouseMove = (event) => {
      event.preventDefault();
      if (!currentTextBlock.value) return;
      
      const diffX = event.clientX - startTextX.value;
      const diffY = event.clientY - startTextY.value;
      
      currentTextBlock.value.left += diffX;
      currentTextBlock.value.top += diffY;
      
      startTextX.value = event.clientX;
      startTextY.value = event.clientY;
    };
    
    const stopDraggingText = async () => {
      if (currentTextBlock.value) {
        // Sauvegarder automatiquement la nouvelle position
        try {
          await saveCustomTexts();
        } catch (error) {
          console.error('Erreur lors de la sauvegarde automatique:', error);
        }
      }
      
      currentTextBlock.value = null;
      document.removeEventListener("mousemove", handleTextMouseMove);
      document.removeEventListener("mouseup", stopDraggingText);
    };
    
    const formatText = (command) => {
      document.execCommand(command, false, null);
    };
    
    // Fonction pour calculer les dimensions automatiques d'un texte
    const calculateTextDimensions = (content, fontFamily, fontSize) => {
      // Créer un élément temporaire pour mesurer le texte
      const tempElement = document.createElement('div');
      tempElement.style.position = 'absolute';
      tempElement.style.visibility = 'hidden';
      tempElement.style.whiteSpace = 'pre-wrap';
      tempElement.style.fontFamily = fontFamily;
      tempElement.style.fontSize = fontSize + 'px';
      tempElement.style.padding = '10px';
      tempElement.style.border = '1px solid transparent';
      tempElement.style.maxWidth = '400px'; // Largeur maximale
      tempElement.innerHTML = content;
      
      document.body.appendChild(tempElement);
      
      const width = Math.max(150, Math.min(400, tempElement.offsetWidth + 20)); // Min 150px, Max 400px
      const height = Math.max(50, tempElement.offsetHeight + 20); // Min 50px
      
      document.body.removeChild(tempElement);
      
      return { width, height };
    };

    const openNewTextBlock = async () => {
      // Nouveau bloc : pré-remplir depuis la charte (valeurs par défaut, modifiables ensuite)
      editingTextIndex.value = -1;
      selectedFont.value = hasCharte.value ? charte.value.text_font : 'Arial';
      textFontSize.value = hasCharte.value ? charte.value.text_size : 16;
      textColor.value = hasCharte.value ? charte.value.text_color : '#000000';
      textBackgroundColor.value = 'transparent';
      showTextEditor.value = true;
      await nextTick();
      if (textEditor.value) textEditor.value.textContent = '';
    };

    const saveTextBlock = async () => {
      if (textEditor.value) {
        const content = textEditor.value.innerHTML;
        
        if (editingTextIndex.value === -1) {
          // Calculer les dimensions automatiques
          const dimensions = calculateTextDimensions(content, selectedFont.value, textFontSize.value);
          
          // Ajouter un nouveau bloc de texte
          textBlocks.value.push({
            content: content,
            top: 100,
            left: 100,
            width: dimensions.width,
            height: dimensions.height,
            fontFamily: selectedFont.value,
            fontSize: textFontSize.value,
            color: textColor.value,
            backgroundColor: textBackgroundColor.value,
            borderWidth: 0,
            borderStyle: 'solid',
            borderColor: '#000000',
            borderRadius: 0,
            boxShadow: 'none'
          });
          
          // Initialiser les arrays de contrôle pour ce bloc
          showTextBorderMenu.value.push(false);
          showTextShadowMenu.value.push(false);
        } else {
          // Calculer les nouvelles dimensions pour le bloc existant
          const dimensions = calculateTextDimensions(content, selectedFont.value, textFontSize.value);
          
          // Mettre à jour un bloc existant
          textBlocks.value[editingTextIndex.value] = {
            ...textBlocks.value[editingTextIndex.value],
            content: content,
            width: dimensions.width,
            height: dimensions.height,
            fontFamily: selectedFont.value,
            fontSize: textFontSize.value,
            color: textColor.value,
            backgroundColor: textBackgroundColor.value
          };
        }
        
        showTextEditor.value = false;
        editingTextIndex.value = -1;
        textEditor.value.innerHTML = '';
        
        // Sauvegarder automatiquement après modification
        try {
          await saveCustomTexts();
        } catch (error) {
          console.error('Erreur lors de la sauvegarde automatique:', error);
        }
        //Recharger les customsTexts
        try {
          await loadSavedTexts();
        } catch (error) {
            console.error('Erreur lors de la récupération automatique:', error);

        }
      }
    };
    
    const editTextBlock = (index) => {
      const block = textBlocks.value[index];
      editingTextIndex.value = index;
      
      // Définir les valeurs dans l'éditeur
      selectedFont.value = block.fontFamily;
      textFontSize.value = block.fontSize;
      textColor.value = block.color;
      textBackgroundColor.value = block.backgroundColor;
      
      showTextEditor.value = true;
      
      // Mettre le contenu dans l'éditeur après que le dialogue soit affiché
      setTimeout(() => {
        if (textEditor.value) {
          textEditor.value.innerHTML = block.content;
        }
      }, 100);
    };
    
    const deleteTextBlock = async (index) => {
      if (confirm('Êtes-vous sûr de vouloir supprimer ce texte ?')) {
        const block = textBlocks.value[index];
        
        // Si le texte a un ID, le supprimer du serveur
        if (block.id) {
          try {
            await axios.delete(`${process.env.VUE_APP_BASEURL}/custom-texts/${block.id}`);
          } catch (error) {
            console.error('Erreur lors de la suppression du texte:', error);
          }
        }
        
        // Supprimer le texte localement
        textBlocks.value.splice(index, 1);
        showTextBorderMenu.value.splice(index, 1);
        showTextShadowMenu.value.splice(index, 1);
      }
    };
    
    const updateTextBorderWidth = (index) => {
      if (textBlocks.value[index]) {
        textBlocks.value[index].borderWidth = textBorderWidth.value;
      }
    };
    
    const updateTextBorderColor = (index) => {
      if (textBlocks.value[index]) {
        textBlocks.value[index].borderColor = textBorderColor.value;
      }
    };
    
    const updateTextBorderRadius = (index) => {
      if (textBlocks.value[index]) {
        textBlocks.value[index].borderRadius = textBorderRadius.value;
      }
    };
    
    const updateTextShadow = (index) => {
      if (textBlocks.value[index]) {
        const shadowStyle = `${textShadowX.value}px ${textShadowY.value}px ${textShadowBlur.value}px ${textShadowColor.value}`;
        textBlocks.value[index].boxShadow = shadowStyle;
      }
    };
    
    // Fonction utilitaire pour valider et convertir les dimensions
    const validateDimensions = (width, height) => {
      // Vérifier si les dimensions sont valides (non null, non undefined, non vide, et numérique)
      const isValidWidth = width !== null && width !== undefined && width !== '' && !isNaN(width) && Number(width) > 0;
      const isValidHeight = height !== null && height !== undefined && height !== '' && !isNaN(height) && Number(height) > 0;
      
      const validWidth = isValidWidth ? Math.max(50, Number(width)) : 200;
      const validHeight = isValidHeight ? Math.max(30, Number(height)) : 100;
      
      return { 
        width: validWidth, 
        height: validHeight,
        needsUpdate: !isValidWidth || !isValidHeight // Indique si une mise à jour en base est nécessaire
      };
    };

    // Fonction pour mettre à jour les dimensions en base de données
    const updateDimensionsInDatabase = async (textsToUpdate, originalTexts) => {
      try {
        const updatePromises = textsToUpdate.map(async (textUpdate) => {
          const url = `${process.env.VUE_APP_BASEURL}/custom-texts/${textUpdate.id}`;
          
          // Trouver le texte correspondant dans les données originales
          const originalText = originalTexts.find(text => text.id === textUpdate.id);
          
          if (originalText) {
            // Mettre à jour avec les nouvelles dimensions
            const updateData = {
              point_id: originalText.point_id,
              content: originalText.content,
              position_top: originalText.position_top,
              position_left: originalText.position_left,
              width: textUpdate.width,
              height: textUpdate.height,
              font_family: originalText.font_family,
              font_size: originalText.font_size,
              color: originalText.color,
              background_color: originalText.background_color,
              border_width: originalText.border_width,
              border_style: originalText.border_style,
              border_color: originalText.border_color,
              border_radius: originalText.border_radius,
              box_shadow: originalText.box_shadow
            };
            console.log(`Mise à jour du texte ${textUpdate.id} avec:`, updateData);
             return axios.put(url, updateData);
          }
        });
        
        await Promise.all(updatePromises.filter(Boolean)); // Filtrer les undefined
        console.log('Dimensions mises à jour avec succès en base de données');
      } catch (error) {
        console.error('Erreur lors de la mise à jour des dimensions en base:', error);
      }
    };

    // Charger les textes enregistrés pour ce point
    const loadSavedTexts = async () => {
      try {
        // Utiliser l'endpoint existant pour récupérer les textes par point_id
        const url = `${process.env.VUE_APP_BASEURL}/custom-texts/point/${selectedPointId.value}`;
        const response = await axios.get(url);
        
        if (response.data && response.data.length) {
          // Transformer les données reçues au format utilisé par le composant
          const textsNeedingUpdate = [];
          
          textBlocks.value = response.data.map(text => {
            // Validation et conversion des dimensions
            const dimensions = validateDimensions(text.width, text.height);
            
            // Si les dimensions ont besoin d'être mises à jour en base
            if (dimensions.needsUpdate && text.id) {
              textsNeedingUpdate.push({
                id: text.id,
                width: dimensions.width,
                height: dimensions.height
              });
            }
            
            return {
              id: text.id,
              content: text.content,
              top: text.position_top,
              left: text.position_left,
              width: dimensions.width,
              height: dimensions.height,
              fontFamily: text.font_family,
              fontSize: text.font_size,
              color: text.color,
              backgroundColor: text.background_color,
              borderWidth: text.border_width,
              borderStyle: text.border_style,
              borderColor: text.border_color,
              borderRadius: text.border_radius,
              boxShadow: text.box_shadow
            };
          });
          
          // Mettre à jour les dimensions en base de données si nécessaire
          if (textsNeedingUpdate.length > 0) {
            await updateDimensionsInDatabase(textsNeedingUpdate, response.data);
          }
          
          // Initialiser les contrôles pour chaque bloc
          textBlocks.value.forEach(() => {
            showTextBorderMenu.value.push(false);
            showTextShadowMenu.value.push(false);
          });
        }
      } catch (error) {
        console.error('Erreur lors du chargement des textes personnalisés:', error);
      }
    };
    
    // Sauvegarder les textes pour ce point
    const saveCustomTexts = async () => {
      try {
        // Créer un tableau de promesses, une pour chaque texte
        const savePromises = textBlocks.value.map(async (textBlock) => {
          // Si le texte a un ID, c'est une mise à jour
          if (textBlock.id) {
            const url = `${process.env.VUE_APP_BASEURL}/custom-texts/${textBlock.id}`;
            const updateData = {
              content: textBlock.content,
              position_top: textBlock.top,
              position_left: textBlock.left,
              width: textBlock.width,
              height: textBlock.height,
              font_family: textBlock.fontFamily,
              font_size: textBlock.fontSize,
              color: textBlock.color,
              background_color: textBlock.backgroundColor,
              border_width: textBlock.borderWidth,
              border_style: textBlock.borderStyle,
              border_color: textBlock.borderColor,
              border_radius: textBlock.borderRadius,
              box_shadow: textBlock.boxShadow
            };
            console.log(`Mise à jour du texte ${textBlock.id} avec:`, updateData);
             return axios.put(url, updateData);
          } 
          // Sinon, c'est une création
          else {
            const url = `${process.env.VUE_APP_BASEURL}/custom-texts`;
            const createData = {
              point_id: selectedPointId.value,
              content: textBlock.content,
              position_top: textBlock.top,
              position_left: textBlock.left,
              width: textBlock.width,
              height: textBlock.height,
              font_family: textBlock.fontFamily,
              font_size: textBlock.fontSize,
              color: textBlock.color,
              background_color: textBlock.backgroundColor,
              border_width: textBlock.borderWidth,
              border_style: textBlock.borderStyle,
              border_color: textBlock.borderColor,
              border_radius: textBlock.borderRadius,
              box_shadow: textBlock.boxShadow
            };
            console.log('Création d\'un nouveau texte avec:', createData);
             return axios.post(url, createData);
          }
        });
        
        // Attendre que toutes les requêtes soient terminées et récupérer les IDs
        const results = await Promise.all(savePromises);
        
        // Mettre à jour les IDs pour les nouveaux textes créés
        let resultIndex = 0;
        textBlocks.value.forEach((textBlock, index) => {
          if (!textBlock.id && results[resultIndex] && results[resultIndex].data && results[resultIndex].data.id) {
            textBlocks.value[index].id = results[resultIndex].data.id;
          }
          resultIndex++;
        });
      } catch (error) {
        console.error('Erreur lors de la sauvegarde des textes personnalisés:', error);
        if (error.response) {
          console.error('Détails de l\'erreur:', error.response.data);
          console.error('Status:', error.response.status);
        }
        throw error;
      }
    };

    // Fonctions de la banque d'éléments
    const selectBankElement = (type, element) => {
      selectedBankElement.value = { ...element, type };
    };

    const generateShapeSvg = (shapeId, fill, stroke, sw) => {
      const ns = 'http://www.w3.org/2000/svg';
      const svg = (vb, inner) => `<svg width="100%" height="100%" viewBox="${vb}" xmlns="${ns}">${inner}</svg>`;
      const poly = (pts) => `<polygon points="${pts}" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`;
      const ln = (x1, y1, x2, y2, vb) => svg(vb, `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${stroke}" stroke-width="${Math.max(sw * 2, 3)}" stroke-linecap="round"/>`);
      switch (shapeId) {
        // Géométrie
        case 'rect':
          return svg('0 0 100 100', `<rect x="${sw}" y="${sw}" width="${100-sw*2}" height="${100-sw*2}" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'rounded-rect':
          return svg('0 0 100 100', `<rect x="${sw}" y="${sw}" width="${100-sw*2}" height="${100-sw*2}" rx="15" ry="15" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'circle':
          return svg('0 0 100 100', `<circle cx="50" cy="50" r="${48-sw}" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'ellipse':
          return svg('0 0 120 80', `<ellipse cx="60" cy="40" rx="${58-sw}" ry="${38-sw}" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'triangle':
          return svg('0 0 100 100', poly(`50,${sw+2} ${98-sw},${98-sw} ${sw+2},${98-sw}`));
        case 'triangle-down':
          return svg('0 0 100 100', poly(`${sw+2},${sw+2} ${98-sw},${sw+2} 50,${98-sw}`));
        case 'diamond':
          return svg('0 0 100 100', poly(`50,${sw+2} ${98-sw},50 50,${98-sw} ${sw+2},50`));
        case 'pentagon':
          return svg('0 0 100 100', poly('50,3 97,36 79,95 21,95 3,36'));
        case 'hexagon':
          return svg('0 0 100 100', poly('50,3 93,25 93,75 50,97 7,75 7,25'));
        case 'octagon':
          return svg('0 0 100 100', poly('30,3 70,3 97,30 97,70 70,97 30,97 3,70 3,30'));
        case 'cross':
          return svg('0 0 100 100', poly('35,5 65,5 65,35 95,35 95,65 65,65 65,95 35,95 35,65 5,65 5,35 35,35'));
        case 'ring':
          return svg('0 0 100 100', `<circle cx="50" cy="50" r="42" fill="none" stroke="${stroke}" stroke-width="${Math.max(sw*3,6)}"/>`);
        case 'semicircle':
          return svg('0 0 100 60', `<path d="M 5,55 A 45,45 0 0,1 95,55 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'parallelogram':
          return svg('0 0 120 80', poly('25,5 115,5 95,75 5,75'));
        case 'trapeze':
          return svg('0 0 100 80', poly('20,5 80,5 98,75 2,75'));
        // Flèches
        case 'arrow-right':
          return svg('0 0 100 100', poly('5,30 60,30 60,10 95,50 60,90 60,70 5,70'));
        case 'arrow-left':
          return svg('0 0 100 100', poly('95,30 40,30 40,10 5,50 40,90 40,70 95,70'));
        case 'arrow-up':
          return svg('0 0 100 100', poly('30,95 30,40 10,40 50,5 90,40 70,40 70,95'));
        case 'arrow-down':
          return svg('0 0 100 100', poly('30,5 30,60 10,60 50,95 90,60 70,60 70,5'));
        case 'arrow-double-h':
          return svg('0 0 100 100', poly('5,50 25,25 25,40 75,40 75,25 95,50 75,75 75,60 25,60 25,75'));
        case 'arrow-double-v':
          return svg('0 0 100 100', poly('50,5 75,25 60,25 60,75 75,75 50,95 25,75 40,75 40,25 25,25'));
        case 'arrow-curved':
          return svg('0 0 100 100', `<path d="M 15,75 Q 15,15 85,15 L 75,5 M 85,15 L 75,25" fill="none" stroke="${stroke}" stroke-width="${Math.max(sw*2,4)}" stroke-linecap="round" stroke-linejoin="round"/>`);
        case 'chevron-right':
          return svg('0 0 60 100', `<polyline points="10,5 50,50 10,95" fill="none" stroke="${stroke}" stroke-width="${Math.max(sw*2,5)}" stroke-linecap="round" stroke-linejoin="round"/>`);
        case 'chevron-left':
          return svg('0 0 60 100', `<polyline points="50,5 10,50 50,95" fill="none" stroke="${stroke}" stroke-width="${Math.max(sw*2,5)}" stroke-linecap="round" stroke-linejoin="round"/>`);
        case 'line-h':
          return ln(5, 10, 95, 10, '0 0 100 20');
        case 'line-v':
          return ln(10, 5, 10, 95, '0 0 20 100');
        case 'line-diag':
          return ln(5, 95, 95, 5, '0 0 100 100');
        // Badges & décorations
        case 'star':
          return svg('0 0 100 100', poly('50,5 61,35 93,36 67,56 77,86 50,70 23,86 33,56 7,36 39,35'));
        case 'star6':
          return svg('0 0 100 100', poly('50,3 62,30 93,20 75,50 93,80 62,70 50,97 38,70 7,80 25,50 7,20 38,30'));
        case 'heart':
          return svg('0 0 100 100', `<path d="M 50,88 C 25,70 3,52 3,30 C 3,12 17,3 30,3 C 40,3 48,10 50,18 C 52,10 60,3 70,3 C 83,3 97,12 97,30 C 97,52 75,70 50,88 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/>`);
        case 'shield':
          return svg('0 0 100 120', `<path d="M 50,5 L 95,20 L 95,60 C 95,85 75,105 50,115 C 25,105 5,85 5,60 L 5,20 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`);
        case 'ribbon':
          return svg('0 0 100 120', `<path d="M 20,5 L 80,5 L 80,90 L 50,72 L 20,90 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`);
        case 'badge-circle':
          return svg('0 0 100 100', `<circle cx="50" cy="50" r="42" fill="${fill}" stroke="${stroke}" stroke-width="${sw}"/><circle cx="50" cy="50" r="34" fill="none" stroke="${stroke}" stroke-width="${Math.max(sw*0.5,1)}" stroke-dasharray="4,3"/>`);
        case 'cloud':
          return svg('0 0 120 80', `<path d="M 30,65 C 10,65 5,50 15,40 C 10,25 25,12 40,18 C 48,5 70,5 80,18 C 95,10 115,22 108,40 C 118,50 110,65 95,65 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`);
        case 'bubble':
          return svg('0 0 100 110', `<path d="M 10,10 L 90,10 Q 95,10 95,15 L 95,65 Q 95,70 90,70 L 55,70 L 40,90 L 40,70 L 10,70 Q 5,70 5,65 L 5,15 Q 5,10 10,10 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`);
        case 'tag':
          return svg('0 0 120 80', `<path d="M 5,10 L 75,10 L 115,40 L 75,70 L 5,70 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/><circle cx="25" cy="40" r="6" fill="${stroke}"/>`);
        case 'banner':
          return svg('0 0 100 130', `<path d="M 10,5 L 90,5 L 90,95 L 50,78 L 10,95 Z" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linejoin="round"/>`);
        default:
          return '';
      }
    };

    const getElementPreview = () => {
      if (!selectedBankElement.value) return '';
      if (selectedBankElement.value.type === 'shape') {
        return generateShapeSvg(selectedBankElement.value.id, shapeFillColor.value, shapeStrokeColor.value, shapeStrokeWidth.value);
      } else {
        return `<span class="material-icons" style="font-size:60px;color:${shapeFillColor.value};user-select:none;">${selectedBankElement.value.id}</span>`;
      }
    };

    const addElementToCanvas = async () => {
      if (!selectedBankElement.value) return;

      let content;
      const size = shapeSize.value;

      if (selectedBankElement.value.type === 'shape') {
        content = generateShapeSvg(selectedBankElement.value.id, shapeFillColor.value, shapeStrokeColor.value, shapeStrokeWidth.value);
      } else {
        const iconFontSize = Math.round((size - 20) * 0.8);
        content = `<div style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;"><span class="material-icons" style="font-size:${iconFontSize}px;color:${shapeFillColor.value};user-select:none;">${selectedBankElement.value.id}</span></div>`;
      }

      const eid = selectedBankElement.value.id;
      const wideShapes = ['ellipse', 'parallelogram', 'trapeze', 'cloud', 'tag'];
      const tallShapes = ['shield', 'ribbon', 'banner', 'bubble'];
      const elemW = eid === 'line-v' ? Math.max(30, Math.round(size * 0.2)) : size;
      const elemH = eid === 'line-h' ? Math.max(30, Math.round(size * 0.2))
        : wideShapes.includes(eid) ? Math.round(size * 0.67)
        : tallShapes.includes(eid) ? Math.round(size * 1.2)
        : size;

      textBlocks.value.push({
        content: content,
        top: 100,
        left: 100,
        width: elemW,
        height: elemH,
        fontFamily: 'Arial',
        fontSize: 16,
        color: '#000000',
        backgroundColor: 'transparent',
        borderWidth: 0,
        borderStyle: 'none',
        borderColor: 'transparent',
        borderRadius: 0,
        boxShadow: 'none'
      });

      showTextBorderMenu.value.push(false);
      showTextShadowMenu.value.push(false);

      showShapeBank.value = false;
      selectedBankElement.value = null;

      try {
        await saveCustomTexts();
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de l\'élément:', error);
      }

      try {
        await loadSavedTexts();
      } catch (error) {
        console.error('Erreur lors du rechargement:', error);
      }
    };

    // Fonctions pour l'upload d'image
    const getUploadFileIcon = (name) => {
      if (!name) return 'insert_drive_file';
      const ext = name.split('.').pop().toLowerCase();
      if (['jpg','jpeg','png','gif','svg','webp','bmp','tiff'].includes(ext)) return 'image';
      if (['mp4','avi','mov','wmv','webm','mkv'].includes(ext)) return 'videocam';
      if (['mp3','wav','ogg','flac','aac'].includes(ext)) return 'audiotrack';
      if (['doc','docx'].includes(ext)) return 'description';
      if (['pdf'].includes(ext)) return 'picture_as_pdf';
      return 'insert_drive_file';
    };

    const addUploadFiles = (files) => {
      for (const file of files) {
        uploadFilesToProcess.value.push({
          file,
          title: file.name.replace(/\.[^/.]+$/, ''),
        });
      }
    };

    const onDialogDrop = (event) => {
      isDialogDragging.value = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) addUploadFiles(files);
    };

    const onUploadFilesSelected = (files) => {
      if (files && files.length > 0) {
        addUploadFiles(files);
        uploadFileInputMulti.value = null;
      }
    };

    const uploadAndAddImage = async () => {
      if (uploadFilesToProcess.value.length === 0) return;

      try {
        uploadingFile.value = true;
        const newResourceIds = [];

        for (let i = 0; i < uploadFilesToProcess.value.length; i++) {
          uploadCurrentIdx.value = i + 1;
          uploadProgress.value = 0;

          const item = uploadFilesToProcess.value[i];
          const formData = new FormData();
          formData.append('file', item.file);
          formData.append('name', item.file.name);
          formData.append('title', item.title);
          formData.append('description', '');
          formData.append('exhibitId', store.state.exhibitId);
          if (store.state.resourcesCount !== undefined) {
            formData.append('index', store.state.resourcesCount);
          }

          const uploadUrl = `${process.env.VUE_APP_BASEURL}/file`;
          const uploadResponse = await axios.post(uploadUrl, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                uploadProgress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }
          });

          if (uploadResponse.status === 200) {
            newResourceIds.push(uploadResponse.data.resourceId);
          }
        }

        // Associer tous les nouveaux fichiers au point courant
        const existingResourceIds = resources.value.map(r => r.resource_id);
        const allResourceIds = [...existingResourceIds, ...newResourceIds];
        const assocUrl = `${process.env.VUE_APP_BASEURL}/pointresourceassociation/${selectedPointId.value}`;
        await axios.post(assocUrl, allResourceIds);

        // Rafraîchir l'affichage
        await getResourcesFromPoints();
        await handleSelect();
        await fetchAnimations();
        await getAllResources();

        // Fermer le dialog et réinitialiser
        showImageUploader.value = false;
        uploadFilesToProcess.value = [];
        uploadProgress.value = 0;

        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
      } catch (error) {
        console.error('Erreur lors de l\'upload:', error);
        errorBanner.value = true;
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500);
      } finally {
        uploadingFile.value = false;
      }
    };

    const deleteAssociation = async (resourceId) => {
      if (window.confirm('Êtes-vous sûr de vouloir supprimer cette association ?')) {
        try {
          visible.value = true;
          // Supprimer l'association dans le backend
          let url = `${process.env.VUE_APP_BASEURL}/pointresourceAssociation/${resourceId}`;
          await axios.delete(url);
          
          // Récupérer les ressources mises à jour depuis le backend
          const updatedResourcesResponse = await axios.get(
            `${process.env.VUE_APP_BASEURL}/resourcesFromPointWithAssociations/${selectedPointId.value}`
          );
          
          // Extraire les IDs des ressources restantes
          const updatedResourceIds = updatedResourcesResponse.data.map(item => item.resource_id);
          
          // Mettre à jour l'état local
          await getResourcesFromPoints();
          await handleSelect();
          
          // Mettre à jour le store pour ResourceManagement.vue
          store.commit("SET_POINTSELECTED", store.state.pointSelected);
          
          // Forcer la mise à jour de ResourceManagement.vue en déclenchant 
          // un événement dans le store qui sera détecté par getResourcesFromPoints
          store.commit("SET_RESOURCESFROMPOINTS", updatedResourceIds);
          
          success.value = true;
          setTimeout(() => {
            success.value = false;
            visible.value = false;
          }, 1500);
        } catch (error) {
          console.log(error);
          errorBanner.value = true;
          visible.value = false;
          setTimeout(() => {
            errorBanner.value = false;
          }, 1500);
        }
      }
    };
    
    // Fonctions pour gérer l'image de fond
    const getAllResources = async () => {
      try {
        const url = `${process.env.VUE_APP_BASEURL}/resources/${store.state.exhibitId}`;
        const response = await axios.get(url);
        allResources.value = response.data;
        
        // Charger les aperçus des images
        for (let resource of allResources.value) {
          if (isImage(resource.name)) {
            try {
              const imgUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
              const imgResponse = await axios.get(imgUrl);
              resource.imgSrc = imgResponse.data;
            } catch (error) {
              console.error(`Erreur lors du chargement de l'aperçu pour ${resource.name}:`, error);
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des ressources:', error);
      }
    };
    
    const selectBackgroundImage = (resource) => {
      selectedBackgroundImage.value = resource.resource_id;
    };
    
    const applyBackgroundImage = async () => {
      if (selectedBackgroundImage.value) {
        try {
          const selectedResource = allResources.value.find(r => r.resource_id === selectedBackgroundImage.value);
          
          if (selectedResource && selectedResource.imgSrc) {
            backgroundImage.value = selectedResource.imgSrc;
            
            // Sauvegarder l'ID de l'image de fond dans le backend
            await saveBackgroundImageId(selectedResource.resource_id);
            
            showBackgroundImageSelector.value = false;
            success.value = true;
            setTimeout(() => {
              success.value = false;
            }, 1500);
          }
        } catch (error) {
          console.error('Erreur lors de l\'application de l\'image de fond:', error);
          errorBanner.value = true;
          setTimeout(() => {
            errorBanner.value = false;
          }, 1500);
        }
      }
    };
    
    const removeBackgroundImage = async () => {
      backgroundImage.value = null;
      selectedBackgroundImage.value = null;
      
      try {
        // Supprimer l'ID de l'image de fond dans le backend
        await saveBackgroundImageId(null);
        
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 1500);
      } catch (error) {
        console.error('Erreur lors de la suppression de l\'image de fond:', error);
        errorBanner.value = true;
        setTimeout(() => {
          errorBanner.value = false;
        }, 1500);
      }
    };
    
    const saveBackgroundImageId = async (resourceId) => {
      try {
        const checkUrl = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/point/${selectedPointId.value}`;
        
        // D'abord vérifier si une entrée existe déjà
        try {
          const checkResponse = await axios.get(checkUrl);
          console.log("Vérification de l'existence d'une image de fond:", checkResponse.data);
          
          // Si on arrive ici, l'entrée existe
          if (checkResponse.data && (checkResponse.data.length > 0 || checkResponse.data.id)) {
            // Utiliser PUT pour mettre à jour
            const updateUrl = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/${
              checkResponse.data.id || 
              (checkResponse.data[0] ? checkResponse.data[0].id : selectedPointId.value)
            }`;
            
            console.log("Mise à jour de l'image de fond avec PUT:", updateUrl);
            await axios.put(updateUrl, { resource_id: resourceId });
          } else {
            // Pas d'entrée existante malgré une réponse 200, utiliser POST
            throw { response: { status: 404 } }; // Force l'utilisation du POST
          }
        } catch (error) {
          // Si on obtient une erreur 404 ou si l'objet est vide, aucune entrée n'existe encore
          console.log("Création d'une nouvelle entrée avec POST");
          const postUrl = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage`;
          const postData = {
            point_id: selectedPointId.value,
            resource_id: resourceId
          };
          console.log("Données POST:", postData);
          await axios.post(postUrl, postData);
        }
        
      } catch (error) {
        console.error('Erreur lors de la sauvegarde de l\'image de fond:', error);
        throw error;
      }
    };
    
    const loadBackgroundImage = async () => {
      try {
        const url = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/point/${selectedPointId.value}`;
        const response = await axios.get(url);
        
        console.log("Données image de fond reçues:", response.data);
        
        // Vérifier les différentes possibilités de nommage de propriété
        const imageId = response.data?.background_image_id || 
                      response.data?.resource_id || 
                      (response.data[0] ? response.data[0].resource_id : null);
        
        if (imageId) {
          console.log("ID de l'image de fond trouvé:", imageId);
          selectedBackgroundImage.value = imageId;
          
          // Vérifier si allResources est chargé
          if (allResources.value.length === 0) {
            console.log("Ressources non chargées, chargement en cours...");
            await getAllResources();
          }
          
          // Charger l'URL de l'image
          const resourceDetails = allResources.value.find(r => r.resource_id === selectedBackgroundImage.value);
          console.log("Détails de la ressource:", resourceDetails);
          
          if (resourceDetails) {
            const imgUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${resourceDetails.name}`;
            console.log("URL de l'image:", imgUrl);
            const imgResponse = await axios.get(imgUrl);
            console.log("Données de l'image reçues, longueur:", imgResponse.data.length);
            backgroundImage.value = imgResponse.data;
            
            // Force le rafraîchissement du style
            setTimeout(() => {
              const tempStyle = { ...screenContainerStyle.value };
              screenContainerStyle.value = {};
              setTimeout(() => {
                screenContainerStyle.value = tempStyle;
              }, 10);
            }, 10);
          } else {
            console.error("Ressource non trouvée avec l'ID:", selectedBackgroundImage.value);
          }
        } else {
          console.log("Aucune image de fond définie pour ce point");
        }
      } catch (error) {
        console.error('Erreur lors du chargement de l\'image de fond:', error);
      }
    };

    onMounted(() => {
      start();
      scrollToTop(); // Forcer le scroll en haut de la page
      document.addEventListener("mouseup", stopDragging);
      document.addEventListener("mouseup", stopDraggingText); // Pour les textes
      
      // Écouteur pour les changements de taille d'écran
      window.addEventListener('resize', scrollToTop);
      
      // Référence à l'éditeur de texte
      nextTick(() => {
        textEditor.value = document.querySelector('.text-editor-content');
      });
    });

    onUnmounted(() => {
      document.removeEventListener("mouseup", stopDragging);
      document.removeEventListener("mouseup", stopDraggingText); // Pour les textes
      window.removeEventListener('resize', scrollToTop); // Nettoyer l'écouteur de resize
    });

    // Variables pour l'image de fond
    const showBackgroundImageSelector = ref(false);
    const backgroundImage = ref(null);
    const selectedBackgroundImage = ref(null);
    const allResources = ref([]);
    
    // Style calculé pour le conteneur d'écran incluant l'image de fond
    const screenContainerStyle = computed(() => {
      const style = {
        border: 'solid 1px black',
        borderStyle: 'dashed',
        width: '100%',
        height: '95%',
        position: 'relative',
        overflow: 'hidden'
      };
      
      if (backgroundImage.value) {
        try {
          // Vérifier si backgroundImage.value est une URL ou une chaîne base64
          const isBase64 = typeof backgroundImage.value === 'string' && 
                         (backgroundImage.value.startsWith('data:') || 
                          backgroundImage.value.length > 100);
                          
          const isUrl = typeof backgroundImage.value === 'string' && 
                      backgroundImage.value.startsWith('http');
          
          console.log("État de l'image de fond:", {
            type: typeof backgroundImage.value,
            isBase64,
            isUrl,
            preview: typeof backgroundImage.value === 'string' ? 
                    backgroundImage.value.substring(0, 50) + '...' : 'non-string'
          });
          
          if (isBase64 || isUrl) {
            style.backgroundImage = `url("${backgroundImage.value}")`;
            style.backgroundSize = 'cover';
            style.backgroundPosition = 'center';
            style.backgroundRepeat = 'no-repeat';
            
            // Ajouter un petit filtre pour que les éléments par-dessus soient plus visibles
            style.boxShadow = 'inset 0 0 0 2000px rgba(255, 255, 255, 0.3)';
          } else {
            console.warn("Format d'image de fond non reconnu:", 
                        typeof backgroundImage.value, 
                        backgroundImage.value?.substring(0, 100));
          }
        } catch (error) {
          console.error("Erreur lors de l'application de l'image de fond:", error);
        }
      }
      
      return style;
    });

    // Fonction pour basculer l'affichage des contrôles
    const toggleControls = (index) => {
      if (blocks1.value[index]) {
        blocks1.value[index].hideControls = !blocks1.value[index].hideControls;
      }
    };

    return {
      blocks1,
      model,
      options,
      mainResourceId,
      mainResource,
      resourcesFromPoints,
      imgUrls,
      blocks2,
      width,
      height,
      visible,
      success,
      selectedPointId,
      displayStyle,
      name,
      exhibitId,
      color,
      showBorderMenu,
      borderWidth,
      borderColor,
      borderRadius,
      pointSelectedName,
      showShadowMenu,
      startDragging,
      startDragging2,
      getMainResource,
      handleSelect,
      save,
      increaseSize,
      decreaseSize,
      back,
      scrollToTop,
      associator,
      isImage,
      isVideo,
      isAudio,
      isPdf,
      betweenPage,
      resources,
      resourceSelected,
      blocks1Opac,
      blocks2Opac,
      filteredBlocks2,
      saveBackgroundColor,
      animationOptions,
      selectedAnimation,
      sendAnimation,
      errorBanner,
      rotateImage,
      getRotationStyle,
      updateBorderRadius,
      updateBorderWidth,
      updateBorderColor,
      getRotationStyleVideo,
      shadowColor,
      shadowX,
      shadowY,
      shadowBlur,
      updateBlockStyle,
      updateShadow,
      titleColor,
      titleSize,
      getTitleStyle,
      saveTitleParams,
      textBlocks,
      showTextEditor,
      openNewTextBlock,
      textEditor,
      selectedFont,
      textFontSize,
      textColor,
      textBackgroundColor,
      fontOptions,
      showTextBorderMenu,
      textBorderWidth,
      textBorderColor,
      textBorderRadius,
      showTextShadowMenu,
      textShadowColor,
      textShadowX,
      textShadowY,
      textShadowBlur,
      getTextBlockContentStyle,
      startDraggingText,
      formatText,
      saveTextBlock,
      editTextBlock,
      deleteTextBlock,
      updateTextBorderWidth,
      updateTextBorderColor,
      updateTextBorderRadius,
      updateTextShadow,
      loadSavedTexts,
      saveCustomTexts,
      saveAll,
      startResizing,
      handleResizeMove,
      stopResizing,
      startResizingText,
      handleTextResizeMove,
      stopResizingText,
      animationSpeedOptions,
      animationDelayOptions,
      animationRepeatOptions,
      previewAnimation,
      showRotationMenu,
      deleteAssociation,
      isDocx,
      screenContainerStyle,
      showBackgroundImageSelector,
      backgroundImage,
      selectedBackgroundImage,
      allResources,
      selectBackgroundImage,
      applyBackgroundImage,
      removeBackgroundImage,
      getAllResources,
      toggleControls,
      showShapeBank,
      selectedBankElement,
      shapeFillColor,
      shapeStrokeColor,
      shapeStrokeWidth,
      shapeSize,
      shapeSizeOptions,
      shapesCatalog,
      libraryIconsCatalog,
      iconCategories,
      selectBankElement,
      getElementPreview,
      addElementToCanvas,
      showImageUploader,
      uploadFileInputMulti,
      uploadFilesToProcess,
      uploadProgress,
      uploadingFile,
      uploadCurrentIdx,
      isDialogDragging,
      getUploadFileIcon,
      addUploadFiles,
      onDialogDrop,
      onUploadFilesSelected,
      uploadAndAddImage
    };
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.06);
}

.block {
  position: absolute;
  z-index: 10000;
  cursor: move;
}

.resize-handle {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #1976d2;
  border: 1px solid white;
  border-radius: 50%;
  z-index: 100;
}

.top-left {
  top: -6px;
  left: -6px;
  cursor: nw-resize;
}

.top-right {
  top: -6px;
  right: -6px;
  cursor: ne-resize;
}

.bottom-left {
  bottom: -6px;
  left: -6px;
  cursor: sw-resize;
}

.bottom-right {
  bottom: -6px;
  right: -6px;
  cursor: se-resize;
}

.select-section {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  flex-wrap: wrap;
}

.toolbar-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 4px 0;
}

.toolbar-label {
  font-size: 12px;
  color: #666;
  margin-right: 8px;
  font-weight: 500;
  min-width: 60px;
}

.back-btn {
  margin-left: 0;
}

@media (max-width: 768px) {
  .select-section {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .toolbar-group {
    width: 100%;
    margin: 4px 0;
  }
  
  .q-separator.vertical {
    display: none;
  }
}

.banner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;

  /* Design */
  padding: 15px 30px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  /* Typographie */
  font-size: 16px;
  font-family: 'Helvetica', sans-serif;
  /* Remplacez par la police de votre choix */

  /* Transition */
  transition: all 0.3s ease-in-out;
}

.cartel {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.cartel h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: #333;
}

.cartel p {
  margin-bottom: 15px;
}

.cartel a {
  color: #1a73e8;
  text-decoration: none;
  font-weight: 500;
}

.cartel a:hover {
  text-decoration: underline;
}

.img {
  width: 100%;
  height: auto;
  max-width: 100vw;
  max-height: 100vh;
}

.video-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  background-color: #000;
}

.docx-container {
  background-color: white;
  overflow-y: auto;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.docx-content {
  font-family: 'Calibri', Arial, sans-serif;
  line-height: 1.5;
  color: #333;
}

.docx-content h1, 
.docx-content h2, 
.docx-content h3 {
  margin-top: 1em;
  margin-bottom: 0.5em;
  color: #222;
}

.docx-content p {
  margin-bottom: 0.8em;
}

.docx-content ul, 
.docx-content ol {
  margin-left: 1.5em;
  margin-bottom: 1em;
}

.docx-content table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 1em;
}

.docx-content td, 
.docx-content th {
  border: 1px solid #ddd;
  padding: 8px;
}

.opac {
  opacity: 0.5;
  z-index: 100;
}

.displayNone {
  display: none;
}

.borderMenu {
  position: absolute;
  right: 0;
  bottom: 0;
}

.shadowMenu {
  position: absolute;
  right: 0;
  bottom: 0;
}

.rotationMenu {
  position: absolute;
  right: 0;
  bottom: 0;
}

.screenContainer {
  border: solid 1px black;
  border-style: dashed;
  width: 100%;
  height: 95%;
}

.text-block-wrapper {
  position: relative;
}

.text-block-wrapper:hover .text-block-controls {
  display: flex !important;
}

.text-block-content {
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%;
  box-sizing: border-box;
}

.text-block-controls {
  display: none;
  position: absolute;
  top: -40px;
  left: 0;
  background-color: rgba(255,255,255,0.9);
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  z-index: 999;
  gap: 5px;
}

.text-editor-content {
  border: 1px solid #ddd;
  min-height: 200px;
  padding: 10px;
  overflow-y: auto;
  margin-top: 10px;
}

.text-editor-toolbar {
  border: 1px solid #ddd;
  border-bottom: none;
  padding: 5px;
  background-color: #f8f8f8;
}

.bg-image-card {
  transition: all 0.3s ease;
  border: 2px solid transparent;
  cursor: pointer;
}

.bg-image-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.bg-image-selected {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.5);
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shape-bank-actions {
  border-top: 1px solid #e0e0e0;
  background: #fff;
}

.shape-bank-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(75px, 1fr));
  gap: 6px;
}

.shape-bank-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 4px;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  background-color: #f5f5f5;
}

.shape-bank-item:hover {
  background-color: #e0e0e0;
  transform: translateY(-1px);
}

.shape-bank-item--selected {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.shape-bank-label {
  font-size: 10px;
  margin-top: 3px;
  text-align: center;
  line-height: 1.2;
  color: #666;
}

.shape-bank-preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  background-color: #fafafa;
  border: 1px dashed #ccc;
  border-radius: 8px;
  padding: 12px;
}

.shape-bank-preview-content {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
